// // Testing logging in functionality

// // src/components/ProtectedComponent.js
// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { auth } from '../firebase';

// function ProtectedComponent() {
//     const [data, setData] = useState(null);
//     const [error, setError] = useState(null);

//     useEffect(() => {
//         const fetchData = async () => {
//             const user = auth.currentUser;
//             if (user) {
//                 try {
//                     const idToken = await user.getIdToken(true); // force refresh the token
//                     const response = await axios.get('http://localhost:8000/api/protected/', {
//                         headers: {
//                             Authorization: `Bearer ${idToken}`,
//                         },
//                     });
//                     setData(response.data);
//                 } catch (err) {
//                     setError(err.response ? err.response.data : err.message);
//                 }
//             }
//         };

//         fetchData();
//     }, []);

//     return (
//         <div>
//             <h1>Protected Data</h1>
//             {error && <p>Error: {error}</p>}
//             {data ? <pre>{JSON.stringify(data, null, 2)}</pre> : <p>Loading...</p>}
//         </div>
//     );
// }

// export { ProtectedComponent };

// // Testing retrieving users FeedLots
// src/components/ProtectedComponent.js
// Protected_Login.js
// import React, { useState, useEffect } from 'react';
// import { getAuth } from 'firebase/auth';
// import { doc, getDoc } from 'firebase/firestore';
// import { db } from '../firebase'; // Import db from firebase

// function ProtectedComponent() {
//     const [feedlotData, setFeedlotData] = useState([]);
//     const [error, setError] = useState(null);

//     useEffect(() => {
//         const fetchData = async () => {
//             const auth = getAuth();
//             const user = auth.currentUser;
//             if (user) {
//                 try {
//                     const userDocRef = doc(db, 'users', user.uid); // Adjust path as needed
//                     const userDocSnap = await getDoc(userDocRef);

//                     if (userDocSnap.exists()) {
//                         const userData = userDocSnap.data();
//                         const feedlotRefs = userData.Feedlots; // Adjust field name as needed

//                         if (feedlotRefs && Array.isArray(feedlotRefs)) {
//                             const feedlotPromises = feedlotRefs.map((ref, index) => {
//                                 console.log(`Fetching feedlot reference ${index + 1}/${feedlotRefs.length}:`, ref);
//                                 return getDoc(ref).then(feedlotDoc => {
//                                     if (feedlotDoc.exists()) {
//                                         return feedlotDoc.data();
//                                     } else {
//                                         console.warn(`Feedlot document not found for reference ${index + 1}`);
//                                         return null;
//                                     }
//                                 }).catch(err => {
//                                     console.error(`Error fetching feedlot reference ${index + 1}:`, err);
//                                     return null;
//                                 });
//                             });
//                             const feedlotDocs = await Promise.all(feedlotPromises);

//                             const feedlotDataArray = feedlotDocs.filter(data => data !== null);
//                             setFeedlotData(feedlotDataArray);
//                             console.log(`Fetched ${feedlotDataArray.length}/${feedlotRefs.length} feedlots successfully.`);
//                         } else {
//                             setError('Feedlots field is missing or not an array');
//                             console.error('Feedlots field is missing or not an array');
//                         }
//                     } else {
//                         setError('User document not found');
//                         console.error('User document not found');
//                     }
//                 } catch (err) {
//                     setError(err.message);
//                     console.error('Error fetching user document:', err);
//                 }
//             } else {
//                 setError('No authenticated user');
//                 console.error('No authenticated user');
//             }
//         };

//         fetchData();
//     }, []);

//     const styles = {
//         container: {
//             fontFamily: 'Arial, sans-serif',
//             maxWidth: '600px',
//             margin: '0 auto',
//             padding: '20px',
//             borderRadius: '10px',
//             backgroundColor: '#f9f9f9',
//             boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
//         },
//         heading: {
//             textAlign: 'center',
//             color: '#333',
//         },
//         error: {
//             color: 'red',
//             textAlign: 'center',
//         },
//         dataBlock: {
//             margin: '20px 0',
//             padding: '10px',
//             border: '1px solid #ddd',
//             borderRadius: '5px',
//             backgroundColor: '#fff',
//         },
//         pre: {
//             whiteSpace: 'pre-wrap',
//             wordBreak: 'break-all',
//         },
//     };

//     return (
//         <div style={styles.container}>
//             <h1 style={styles.heading}>Protected Data</h1>
            
//             {error && <p style={styles.error}>Error: {error}</p>}
//             {feedlotData.length > 0 ? (
//                 feedlotData.map((data, index) => (
//                     <div key={index} style={styles.dataBlock}>
//                         <h2>Feedlot Name: {data.Name || `Feedlot ${index + 1}`}</h2>
//                         <h4>SarComputerID: {data.SarCompID || 'No SarComp Connected'}</h4>
//                         <p>All Information:</p>
//                         <pre style={styles.pre}>{JSON.stringify(data, null, 2)}</pre>
//                     </div>
//                 ))
//             ) : (
//                 <p>No Feedlots found</p>
//             )}
//         </div>
//     );
// }

// export {ProtectedComponent};


// // Shows Users User Data and FeedLots associated with user
// import React, { useState, useEffect } from 'react';
// import { getAuth } from 'firebase/auth';
// import { doc, getDoc } from 'firebase/firestore';
// import { db } from '../firebase'; // Import db from firebase

// function ProtectedComponent() {
//     const [userData, setUserData] = useState(null);
//     const [feedlotData, setFeedlotData] = useState([]);
//     const [error, setError] = useState(null);

//     useEffect(() => {
//         const fetchData = async () => {
//             const auth = getAuth();
//             const user = auth.currentUser;
//             if (user) {
//                 try {
//                     const userDocRef = doc(db, 'users', user.uid); // Adjust path as needed
//                     const userDocSnap = await getDoc(userDocRef);

//                     if (userDocSnap.exists()) {
//                         const userData = userDocSnap.data();
//                         const { Feedlots, ...otherUserData } = userData;
//                         setUserData(otherUserData);

//                         if (Feedlots && Array.isArray(Feedlots)) {
//                             const feedlotPromises = Feedlots.map(ref => getDoc(ref));
//                             const feedlotDocs = await Promise.all(feedlotPromises);

//                             const feedlotDataArray = feedlotDocs
//                                 .map(feedlotDoc => feedlotDoc.exists() ? feedlotDoc.data() : null)
//                                 .filter(data => data !== null);

//                             setFeedlotData(feedlotDataArray);
//                         } else {
//                             setError('Feedlots field is missing or not an array');
//                         }
//                     } else {
//                         setError('User document not found');
//                     }
//                 } catch (err) {
//                     setError(err.message);
//                 }
//             } else {
//                 setError('No authenticated user');
//             }
//         };

//         fetchData();
//     }, []);

//     const styles = {
//         container: {
//             fontFamily: 'Arial, sans-serif',
//             maxWidth: '600px',
//             margin: '0 auto',
//             padding: '20px',
//             borderRadius: '10px',
//             backgroundColor: '#f9f9f9',
//             boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
//         },
//         heading: {
//             textAlign: 'center',
//             color: '#333',
//         },
//         error: {
//             color: 'red',
//             textAlign: 'center',
//         },
//         dataBlock: {
//             margin: '20px 0',
//             padding: '10px',
//             border: '1px solid #ddd',
//             borderRadius: '5px',
//             backgroundColor: '#fff',
//         },
//         pre: {
//             whiteSpace: 'pre-wrap',
//             wordBreak: 'break-all',
//         },
//     };

//     return (
//         <div style={styles.container}>
//             <h1 style={styles.heading}>Protected Data</h1>
//             {error && <p style={styles.error}>Error: {error}</p>}
//             {userData && (
//                 <div style={styles.dataBlock}>
//                     <h2>User Data: {userData.Name}</h2>
//                     <pre style={styles.pre}>{JSON.stringify(userData, null, 2)}</pre>
//                 </div>
//             )}
//             {feedlotData.length > 0 && (
//                 <div style={styles.dataBlock}>
//                     <h2>Feedlot Data:</h2>
//                     {feedlotData.map((data, index) => (
//                         <div key={index} style={{ marginBottom: '10px' }}>
//                             <h3>{data.Name || `Feedlot ${index + 1}`}</h3>
//                             <pre style={styles.pre}>{JSON.stringify(data, null, 2)}</pre>
//                         </div>
//                     ))}
//                 </div>
//             )}
//         </div>
//     );
// }
// export {ProtectedComponent};



// // // Shows Users User Data and FeedLots associated with user with their respective SarComputer or TMRO ID basic info
// import React, { useState, useEffect } from 'react';
// import { getAuth } from 'firebase/auth';
// import { doc, getDoc, collection, getDocs } from 'firebase/firestore';
// import { db } from '../firebase'; // Import db from firebase

// function ProtectedComponent() {
//     const [userData, setUserData] = useState(null);
//     const [feedlots, setFeedlots] = useState([]);
//     const [selectedFeedlot, setSelectedFeedlot] = useState(null);
//     const [currentData, setCurrentData] = useState(null);
//     const [currentData2, setCurrentData2] = useState(null);
//     const [error, setError] = useState(null);

//     useEffect(() => {
//         const fetchData = async () => {
//             const auth = getAuth();
//             const user = auth.currentUser;
//             if (user) {
//                 try {
//                     const userDocRef = doc(db, 'users', user.uid); // Adjust path as needed
//                     const userDocSnap = await getDoc(userDocRef);

//                     if (userDocSnap.exists()) {
//                         const userData = userDocSnap.data();
//                         const { Feedlots, ...otherUserData } = userData;
//                         setUserData(otherUserData);

//                         if (Feedlots && Array.isArray(Feedlots)) {
//                             const feedlotPromises = Feedlots.map(ref => getDoc(ref));
//                             const feedlotDocs = await Promise.all(feedlotPromises);

//                             const feedlotDataArray = feedlotDocs
//                                 .map(feedlotDoc => feedlotDoc.exists() ? feedlotDoc.data() : null)
//                                 .filter(data => data !== null);

//                             setFeedlots(feedlotDataArray);
//                         } else {
//                             setError('Feedlots field is missing or not an array');
//                         }
//                     } else {
//                         setError('User document not found');
//                     }
//                 } catch (err) {
//                     setError(err.message);
//                 }
//             } else {
//                 setError('No authenticated user');
//             }
//         };

//         fetchData();
//     }, []);

//     const fetchCurrentData = async (sarCompID) => {
//         try {
//             const additionalDataRef = doc(db, sarCompID, 'CurrentData'); // Adjust to correct path
//             const additionalDataSnap = await getDoc(additionalDataRef);
//             if (additionalDataSnap.exists()) {
//                 return additionalDataSnap.data();
//             }
//             return null;
//         } catch (err) {
//             throw new Error(`Failed to fetch current data for ${sarCompID}: ${err.message}`);
//         }
//     };
//     const fetchCurrentDataTMRO = async (tMRID) => {
//         try {
//             const additionalTmroRef = doc(db, tMRID, 'CurrentData'); // Adjust to correct path
//             const additionalTmroSnap = await getDoc(additionalTmroRef);
//             if (additionalTmroSnap.exists()) {
//                 return additionalTmroSnap.data();
//             }
//             return null;
//         } catch (err) {
//             throw new Error(`Failed to fetch current data for ${tMRID}: ${err.message}`);
//         }
//     };

//     const handleFeedlotSelect = async (event) => {
//         const feedlotIndex = event.target.value;
//         const feedlot = feedlots[feedlotIndex];
//         setSelectedFeedlot(feedlot);
//         if (feedlot && feedlot.SarCompID) {
//             console.log('Fetching additional data for SarCompID:', feedlot.SarCompID);
//             try {
//                 const data = await fetchCurrentData(feedlot.SarCompID);
//                 console.log('Current data fetched SarComputer:', data);
//                 setCurrentData(data);
//             } catch (err) {
//                 setError(err.message);
//             }
//         } else {
//             setCurrentData(null);
//         }
//         if (feedlot && feedlot.TMRID) {
//             console.log('Fetching additional data for TMRO ID:', feedlot.TMRID);
//             try {
//                 const data2 = await fetchCurrentDataTMRO(feedlot.TMRID);
//                 console.log('Current data fetched TMRO ID:', data2);
//                 setCurrentData2(data2);
//             } catch (err) {
//                 setError(err.message);
//             }
//         } else {
//             setCurrentData2(null);
//         }
//     };

//     const styles = {
//         container: {
//             fontFamily: 'Arial, sans-serif',
//             maxWidth: '800px',
//             margin: '0 auto',
//             padding: '20px',
//             borderRadius: '10px',
//             backgroundColor: '#f9f9f9',
//             boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
//         },
//         heading: {
//             textAlign: 'center',
//             color: '#333',
//         },
//         error: {
//             color: 'red',
//             textAlign: 'center',
//         },
//         dataBlock: {
//             margin: '20px 0',
//             padding: '10px',
//             border: '1px solid #ddd',
//             borderRadius: '5px',
//             backgroundColor: '#fff',
//         },
//         pre: {
//             whiteSpace: 'pre-wrap',
//             wordBreak: 'break-all',
//         },
//         feedlotSelect: {
//             display: 'flex',
//             flexDirection: 'column',
//             alignItems: 'center',
//         },
//         dropdown: {
//             margin: '10px',
//             padding: '10px',
//             cursor: 'pointer',
//             border: '1px solid #ccc',
//             borderRadius: '5px',
//         },
//     };

//     return (
//         <div style={styles.container}>
//             <h1 style={styles.heading}>Protected Data</h1>
//             {error && <p style={styles.error}>Error: {error}</p>}
//             {userData && (
//                 <div style={styles.dataBlock}>
//                     <h2>User Data:</h2>
//                     <pre style={styles.pre}>{JSON.stringify(userData, null, 2)}</pre>
//                 </div>
//             )}
//             {feedlots.length > 0 && (
//                 <div style={styles.feedlotSelect}>
//                     <h2>Select a Feedlot:</h2>
//                     <select style={styles.dropdown} onChange={handleFeedlotSelect}>
//                         <option value="">-- Select a Feedlot --</option>
//                         {feedlots.map((feedlot, index) => (
//                             <option key={index} value={index}>
//                                 {feedlot.Name || `Feedlot ${index + 1}`}
//                             </option>
//                         ))}
//                     </select>
//                 </div>
//             )}
//             {selectedFeedlot && (
//                 <div style={styles.dataBlock}>
//                     <h2>Selected Feedlot: {selectedFeedlot.Name}</h2>
//                     <pre style={styles.pre}>
//                         {JSON.stringify({
//                             Name: selectedFeedlot.Name,
//                             SarCompID: selectedFeedlot.SarCompID,
//                             ...selectedFeedlot
//                         }, null, 2)}
//                     </pre>
//                 </div>
//             )}
//             {currentData && (
//                 <div style={styles.dataBlock}>
//                     <h2>SarComputer ID: {selectedFeedlot.SarCompID} <br></br>Current Data:</h2>
//                     <pre style={styles.pre}>{JSON.stringify(currentData, null, 2)}</pre>
//                 </div>
//             )}
//             {currentData2 && (
//                 <div style={styles.dataBlock}>
//                     <h2>TMRO ID: {selectedFeedlot.TMRID} <br></br>Current Data:</h2>
//                     <pre style={styles.pre}>{JSON.stringify(currentData2, null, 2)}</pre>
//                 </div>
//             )}
//         </div>
//     );
// }



// export {ProtectedComponent};



// // Including live data information
// import React, { useState, useEffect } from 'react';
// import { getAuth } from 'firebase/auth';
// import { doc, getDoc, collection, query, orderBy, limit, onSnapshot } from 'firebase/firestore';
// import { db } from '../firebase'; // Import db from firebase

// function ProtectedComponent() {
//     const [userData, setUserData] = useState(null);
//     const [feedlots, setFeedlots] = useState([]);
//     const [selectedFeedlot, setSelectedFeedlot] = useState(null);
//     const [currentData, setCurrentData] = useState(null);
//     const [currentData2, setCurrentData2] = useState(null);
//     const [realtimeData, setRealtimeData] = useState(null);
//     const [error, setError] = useState(null);

//     useEffect(() => {
//         const fetchData = async () => {
//             const auth = getAuth();
//             const user = auth.currentUser;
//             if (user) {
//                 try {
//                     const userDocRef = doc(db, 'users', user.uid); // Adjust path as needed
//                     const userDocSnap = await getDoc(userDocRef);

//                     if (userDocSnap.exists()) {
//                         const userData = userDocSnap.data();
//                         const { Feedlots, ...otherUserData } = userData;
//                         setUserData(otherUserData);

//                         if (Feedlots && Array.isArray(Feedlots)) {
//                             const feedlotPromises = Feedlots.map(ref => getDoc(ref));
//                             const feedlotDocs = await Promise.all(feedlotPromises);

//                             const feedlotDataArray = feedlotDocs
//                                 .map(feedlotDoc => feedlotDoc.exists() ? feedlotDoc.data() : null)
//                                 .filter(data => data !== null);

//                             setFeedlots(feedlotDataArray);
//                         } else {
//                             setError('Feedlots field is missing or not an array');
//                         }
//                     } else {
//                         setError('User document not found');
//                     }
//                 } catch (err) {
//                     setError(err.message);
//                 }
//             } else {
//                 setError('No authenticated user');
//             }
//         };

//         fetchData();
//     }, []);

//     const convertTimestamp = (timestamp) => {
//         if (!timestamp || !timestamp.seconds) {
//           return null;
//         }
//         const date = new Date(timestamp.seconds * 1000); // Convert seconds to milliseconds
//         return date.toLocaleString(); // Convert date to a readable string
//       };
      
//     const fetchCurrentData = async (sarCompID) => {
//         try {
//             const additionalDataRef = doc(db, sarCompID, 'CurrentData'); // Adjust to correct path
//             const additionalDataSnap = await getDoc(additionalDataRef);
//             if (additionalDataSnap.exists()) {
//                 return additionalDataSnap.data();
//             }
//             return null;
//         } catch (err) {
//             throw new Error(`Failed to fetch current data for ${sarCompID}: ${err.message}`);
//         }
//     };
//     const fetchCurrentDataTMRO = async (tMRID) => {
//         try {
//             const additionalTmroRef = doc(db, tMRID, 'CurrentData'); // Adjust to correct path
//             const additionalTmroSnap = await getDoc(additionalTmroRef);
//             if (additionalTmroSnap.exists()) {
//                 return additionalTmroSnap.data();
//             }
//             return null;
//         } catch (err) {
//             throw new Error(`Failed to fetch current data for ${tMRID}: ${err.message}`);
//         }
//     };

//     const handleFeedlotSelect = async (event) => {
//         const feedlotIndex = event.target.value;
//         const feedlot = feedlots[feedlotIndex];
//         setSelectedFeedlot(feedlot);
//         // setCurrentData(null);  // Clear currentData before fetching new data
//         // setRealtimeData(null); // Clear realtimeData before fetching new data
//         if (feedlot && feedlot.SarCompID) {
//             console.log('Fetching additional data for SarCompID:', feedlot.SarCompID);
//             try {
//                 const data = await fetchCurrentData(feedlot.SarCompID);
//                 console.log('Current data fetched:', data);
//                 setCurrentData(data);
//                 setupRealtimeListener(feedlot.SarCompID);
//             } catch (err) {
//                 setError(err.message);
//             }
//         } else {
//             setCurrentData(null);
//             setRealtimeData(null);
//         }
//           if (feedlot && feedlot.TMRID) {
//             console.log('Fetching additional data for TMRO ID:', feedlot.TMRID);
//             try {
//                 const data2 = await fetchCurrentDataTMRO(feedlot.TMRID);
//                 console.log('Current data fetched TMRO ID:', data2);
//                 setCurrentData2(data2);
//             } catch (err) {
//                 setError(err.message);
//             }
//         } else {
//             setCurrentData2(null);
//         }
        
//     };

//     const setupRealtimeListener = (sarCompID) => {
//         const dataLoggingRef = collection(db, sarCompID, 'Archives', 'DataLogging');
//         const dataLoggingQuery = query(dataLoggingRef, orderBy('timeStamp', 'desc'), limit(1));

//         onSnapshot(dataLoggingQuery, (snapshot) => {
//             if (!snapshot.empty) {
//                 const doc = snapshot.docs[0];
//                 setRealtimeData(doc.data());
//             } else {
//                 setRealtimeData(null);
//             }
//         });
//     };




//     const styles = {
//         container: {
//             fontFamily: 'Arial, sans-serif',
//             maxWidth: '800px',
//             margin: '0 auto',
//             padding: '20px',
//             borderRadius: '10px',
//             backgroundColor: '#f9f9f9',
//             boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
//         },
//         heading: {
//             textAlign: 'center',
//             color: '#333',
//         },
//         error: {
//             color: 'red',
//             textAlign: 'center',
//         },
//         dataBlock: {
//             margin: '20px 0',
//             padding: '10px',
//             border: '1px solid #ddd',
//             borderRadius: '5px',
//             backgroundColor: '#fff',
//         },
//         pre: {
//             whiteSpace: 'pre-wrap',
//             wordBreak: 'break-all',
//         },
//         feedlotSelect: {
//             display: 'flex',
//             flexDirection: 'column',
//             alignItems: 'center',
//         },
//         dropdown: {
//             margin: '10px',
//             padding: '10px',
//             cursor: 'pointer',
//             border: '1px solid #ccc',
//             borderRadius: '5px',
//         },
//     };

//     return (
//         <div style={styles.container}>
//             <h1 style={styles.heading}>Protected Data</h1>
//             {error && <p style={styles.error}>Error: {error}</p>}
//             {userData && (
//                 <div style={styles.dataBlock}>
//                     <h2>User Data: {userData.Name}</h2>
//                     <h4>Name: {userData.Name}</h4>
//                     <h4>Email: {userData.Email}</h4>
//                     <h4>Role: {userData.RoleTitle}</h4>
//                     {/* <pre style={styles.pre}>{JSON.stringify(userData, null, 2)}</pre> */}
//                 </div>
//             )}
//             {feedlots.length > 0 && (
//                 <div style={styles.feedlotSelect}>
//                     <h2>Select a Feedlot:</h2>
//                     <select style={styles.dropdown} onChange={handleFeedlotSelect}>
//                         <option value="">-- Select a Feedlot --</option>
//                         {feedlots.map((feedlot, index) => (
//                             <option key={index} value={index}>
//                                 {feedlot.Name || `Feedlot ${index + 1}`}
//                             </option>
//                         ))}
//                     </select>
//                 </div>
//             )}
//             {selectedFeedlot && (
//                 <div style={styles.dataBlock}>
//                     <h2>Selected Feedlot: {selectedFeedlot.Name}</h2>
//                     {selectedFeedlot.SarCompID && <h4>SarComputer ID: {selectedFeedlot.SarCompID}</h4>}
//                     {selectedFeedlot.SarTimeID && <h4>SarTime ID: {selectedFeedlot.SarTimeID}</h4>}
//                     {selectedFeedlot.TMRID && <h4>TMRO ID: {selectedFeedlot.TMRID}</h4>}
//                     {/* <pre style={styles.pre}>
//                         {JSON.stringify({
//                             Name: selectedFeedlot.Name,
//                             SarCompID: selectedFeedlot.SarCompID,
//                             ...selectedFeedlot
//                         }, null, 2)}
//                     </pre> */}
//                 </div>
//             )}
//             {currentData && (
//                 <div style={styles.dataBlock}>
//                     <h2>SarComputer ID: {selectedFeedlot.SarCompID} <br></br>Current Data:</h2>
//                     {selectedFeedlot.SarCompID && <h4>Readble Time: {convertTimestamp(currentData.timeStamp)}</h4>}
//                     {/* <pre style={styles.pre}>{JSON.stringify(currentData, null, 2)}</pre> */}
//                 </div>
//             )}
//            {currentData2 && (
//                 <div style={styles.dataBlock}>
//                     <h2>TMRO ID: {selectedFeedlot.TMRID} <br></br>Current Data:</h2>
//                     <h4>Readable Time: {convertTimestamp(currentData2.timeStamp)}</h4>
//                     {/* <pre style={styles.pre}>{JSON.stringify(currentData2, null, 2)}</pre> */}
//                 </div>
//             )}
//             {realtimeData && (
//                 <div style={styles.dataBlock}>
//                     <h2>Real-Time Data Logging:</h2>
//                     <h4>Current Timestamp: {convertTimestamp(realtimeData.timeStamp)}</h4>
//                     <h3>Grain Summary:</h3>
//                     <h4>Grain Type: {realtimeData.GrainType}</h4>
//                     <h4>Grain Flow Rate (Lbs/Min): {realtimeData.LbsMin}</h4>
//                     <h4>Grain Today (Lbs): {realtimeData.GrainLbs}</h4>
//                     <h3>Moisture Summary:</h3>
//                     <h4>Incoming Moisture (%): {realtimeData.mInc}%</h4>
//                     <h4>Actual Moisture (%): {realtimeData.mAct}%</h4>
//                     <h4>Target Moisture (%): {realtimeData.mTarg}%</h4>
//                     <h4>Actual Water (GPM): {realtimeData.wAct}</h4>
//                     <h4>Target Water (GPM): {realtimeData.wTarg}</h4>
//                     <h4>Water Variance (%): {realtimeData.wVar}%</h4>
//                     <h3><strong>SarTemp SG:</strong></h3>
//                     <h4><strong>SarTemp SG</strong> Tank Volume: {realtimeData.TankVolume}</h4>
//                     <h4><strong>SarTemp SG</strong> Rate (CC/Min): {realtimeData.SarTempCC}</h4>
//                     {/* <pre style={styles.pre}>{JSON.stringify(realtimeData, null, 2)}</pre> */}
//                 </div>
//             )}
//         </div>
//     );
// }




// export {ProtectedComponent};



// Including live data information // Fixed bug where the previous feedlot live data would show when current feedlot doesn't have any data to show.
// import React, { useState, useEffect } from 'react';
// import { getAuth } from 'firebase/auth';
// import { doc, getDoc, collection, query, orderBy, limit, onSnapshot } from 'firebase/firestore';
// import { db } from '../firebase'; // Import db from firebase

// function ProtectedComponent() {
//     const [userData, setUserData] = useState(null);
//     const [feedlots, setFeedlots] = useState([]);
//     const [selectedFeedlot, setSelectedFeedlot] = useState(null);
//     const [currentData, setCurrentData] = useState(null);
//     const [currentData2, setCurrentData2] = useState(null);
//     const [realtimeData, setRealtimeData] = useState(null);
//     const [unsubscribeRealtimeListener, setUnsubscribeRealtimeListener] = useState(null);
//     const [weeklyAveragesData, setWeeklyAveragesData] = useState(null);
//     const [error, setError] = useState(null);

//     useEffect(() => {
//         const fetchData = async () => {
//             const auth = getAuth();
//             const user = auth.currentUser;
//             if (user) {
//                 try {
//                     const userDocRef = doc(db, 'users', user.uid); // Adjust path as needed
//                     const userDocSnap = await getDoc(userDocRef);

//                     if (userDocSnap.exists()) {
//                         const userData = userDocSnap.data();
//                         const { Feedlots, ...otherUserData } = userData;
//                         setUserData(otherUserData);

//                         if (Feedlots && Array.isArray(Feedlots)) {
//                             const feedlotPromises = Feedlots.map(ref => getDoc(ref));
//                             const feedlotDocs = await Promise.all(feedlotPromises);

//                             const feedlotDataArray = feedlotDocs
//                                 .map(feedlotDoc => feedlotDoc.exists() ? feedlotDoc.data() : null)
//                                 .filter(data => data !== null);

//                             setFeedlots(feedlotDataArray);
//                         } else {
//                             setError('Feedlots field is missing or not an array');
//                         }
//                     } else {
//                         setError('User document not found');
//                     }
//                 } catch (err) {
//                     setError(err.message);
//                 }
//             } else {
//                 setError('No authenticated user');
//             }
//         };

//         fetchData();
//     }, []);

//     const convertTimestamp = (timestamp) => {
//         if (!timestamp || !timestamp.seconds) {
//             return null;
//         }
//         const date = new Date(timestamp.seconds * 1000); // Convert seconds to milliseconds
//         return date.toLocaleString(); // Convert date to a readable string
//     };

//     const fetchCurrentData = async (sarCompID) => {
//         try {
//             const additionalDataRef = doc(db, sarCompID, 'CurrentData'); // Adjust to correct path
//             const additionalDataSnap = await getDoc(additionalDataRef);
//             if (additionalDataSnap.exists()) {
//                 return additionalDataSnap.data();
//             }
//             return null;
//         } catch (err) {
//             throw new Error(`Failed to fetch current data for ${sarCompID}: ${err.message}`);
//         }
//     };

//     const fetchCurrentDataTMRO = async (tMRID) => {
//         try {
//             const additionalTmroRef = doc(db, tMRID, 'CurrentData'); // Adjust to correct path
//             const additionalTmroSnap = await getDoc(additionalTmroRef);
//             if (additionalTmroSnap.exists()) {
//                 return additionalTmroSnap.data();
//             }
//             return null;
//         } catch (err) {
//             throw new Error(`Failed to fetch current data for ${tMRID}: ${err.message}`);
//         }
//     };

//     const handleFeedlotSelect = async (event) => {
//         const feedlotIndex = event.target.value;
//         const feedlot = feedlots[feedlotIndex];
//         setSelectedFeedlot(feedlot);

//         // Unsubscribe from previous realtime listener if it exists
//         if (unsubscribeRealtimeListener) {
//             unsubscribeRealtimeListener();
//             setUnsubscribeRealtimeListener(null);
//         }

//         // Fetch data for the new feedlot
//         if (feedlot && feedlot.SarCompID) {
//             console.log('Fetching additional data for SarCompID:', feedlot.SarCompID);
//             try {
//                 const data = await fetchCurrentData(feedlot.SarCompID);
//                 console.log('Current data fetched:', data);
//                 setCurrentData(data);
//                 setupRealtimeListener(feedlot.SarCompID);
//             } catch (err) {
//                 setError(err.message);
//             }
//         } else {
//             setCurrentData(null);
//             setRealtimeData(null);
//         }

//         if (feedlot && feedlot.TMRID) {
//             console.log('Fetching additional data for TMRO ID:', feedlot.TMRID);
//             try {
//                 const data2 = await fetchCurrentDataTMRO(feedlot.TMRID);
//                 console.log('Current data fetched TMRO ID:', data2);
//                 setCurrentData2(data2);
//             } catch (err) {
//                 setError(err.message);
//             }
//         } else {
//             setCurrentData2(null);
//         }
//     };

//     const setupRealtimeListener = (sarCompID) => {
//         const dataLoggingRef = collection(db, sarCompID, 'Archives', 'DataLogging');
//         const dataLoggingQuery = query(dataLoggingRef, orderBy('timeStamp', 'desc'), limit(1));

//         const unsubscribe = onSnapshot(dataLoggingQuery, (snapshot) => {
//             if (!snapshot.empty) {
//                 const doc = snapshot.docs[0];
//                 setRealtimeData(doc.data());
//             } else {
//                 setRealtimeData(null);
//             }
//         });

//         setUnsubscribeRealtimeListener(() => unsubscribe);
//     };

//     const fetchWeelklyAveragesData = (sarCompID) => {
//         const weeklyDataRef = collection(db, sarCompID, 'Archives', 'DailyAvergaes');
//         const weeklyDataQuery = query(weeklyDataRef, orderBy('timeStamp', 'desc'), limit(7));
//     };

//     const styles = {
//         container: {
//             fontFamily: 'Arial, sans-serif',
//             maxWidth: '800px',
//             margin: '0 auto',
//             padding: '20px',
//             borderRadius: '10px',
//             backgroundColor: '#f9f9f9',
//             boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
//         },
//         heading: {
//             textAlign: 'center',
//             color: '#333',
//         },
//         error: {
//             color: 'red',
//             textAlign: 'center',
//         },
//         dataBlock: {
//             margin: '20px 0',
//             padding: '10px',
//             border: '1px solid #ddd',
//             borderRadius: '5px',
//             backgroundColor: '#fff',
//         },
//         pre: {
//             whiteSpace: 'pre-wrap',
//             wordBreak: 'break-all',
//         },
//         feedlotSelect: {
//             display: 'flex',
//             flexDirection: 'column',
//             alignItems: 'center',
//         },
//         dropdown: {
//             margin: '10px',
//             padding: '10px',
//             cursor: 'pointer',
//             border: '1px solid #ccc',
//             borderRadius: '5px',
//         },
//     };

//     return (
//         <div style={styles.container}>
//             <h1 style={styles.heading}>Protected Data</h1>
//             {error && <p style={styles.error}>Error: {error}</p>}
//             {userData && (
//                 <div style={styles.dataBlock}>
//                     <h2>User Data: {userData.Name}</h2>
//                     <h4>Name: {userData.Name}</h4>
//                     <h4>Email: {userData.Email}</h4>
//                     <h4>Role: {userData.RoleTitle}</h4>
//                 </div>
//             )}
//             {feedlots.length > 0 && (
//                 <div style={styles.feedlotSelect}>
//                     <h2>Select a Feedlot:</h2>
//                     <select style={styles.dropdown} onChange={handleFeedlotSelect}>
//                         <option value="">-- Select a Feedlot --</option>
//                         {feedlots.map((feedlot, index) => (
//                             <option key={index} value={index}>
//                                 {feedlot.Name || `Feedlot ${index + 1}`}
//                             </option>
//                         ))}
//                     </select>
//                 </div>
//             )}
//             {selectedFeedlot && (
//                 <div style={styles.dataBlock}>
//                     <h2>Selected Feedlot: {selectedFeedlot.Name}</h2>
//                     {selectedFeedlot.SarCompID && <h4>SarComputer ID: {selectedFeedlot.SarCompID}</h4>}
//                     {selectedFeedlot.SarTimeID && <h4>SarTime ID: {selectedFeedlot.SarTimeID}</h4>}
//                     {selectedFeedlot.TMRID && <h4>TMRO ID: {selectedFeedlot.TMRID}</h4>}
//                 </div>
//             )}
//             {currentData && (
//                 <div style={styles.dataBlock}>
//                     <h2>SarComputer ID: {selectedFeedlot.SarCompID} <br />Current Data:</h2>
//                     <h4>Readable Time: {convertTimestamp(currentData.timeStamp)}</h4>
//                 </div>
//             )}
//             {currentData2 && (
//                 <div style={styles.dataBlock}>
//                     <h2>TMRO ID: {selectedFeedlot.TMRID} <br />Current Data:</h2>
//                     <h4>Readable Time: {convertTimestamp(currentData2.timeStamp)}</h4>
//                 </div>
//             )}
//             {realtimeData && (
//                 <div style={styles.dataBlock}>
//                     <h2>Real-Time Data Logging:</h2>
//                     <h4>Current Timestamp: {convertTimestamp(realtimeData.timeStamp)}</h4>
//                     <h3>Grain Summary:</h3>
//                     <h4>Grain Type: {realtimeData.GrainType}</h4>
//                     <h4>Grain Flow Rate (Lbs/Min): {realtimeData.LbsMin}</h4>
//                     <h4>Grain Today (Lbs): {realtimeData.GrainLbs}</h4>
//                     <h3>Moisture Summary:</h3>
//                     <h4>Incoming Moisture (%): {realtimeData.mInc}%</h4>
//                     <h4>Actual Moisture (%): {realtimeData.mAct}%</h4>
//                     <h4>Target Moisture (%): {realtimeData.mTarg}%</h4>
//                     <h4>Actual Water (GPM): {realtimeData.wAct}</h4>
//                     <h4>Target Water (GPM): {realtimeData.wTarg}%</h4>
//                     <h4>Water Variance (%): {realtimeData.wVar}%</h4>
//                     <h3><strong>SarTemp SG:</strong></h3>
//                     <h4><strong>SarTemp SG</strong> Tank Volume: {realtimeData.TankVolume}</h4>
//                     <h4><strong>SarTemp SG</strong> Rate (CC/Min): {realtimeData.SarTempCC}</h4>
//                 </div>
//             )}
//         </div>
//     );
// }

// export { ProtectedComponent };


// // //Implemented Logout Fucntion
// import React, { useState, useEffect } from 'react';
// import { getAuth, signOut } from 'firebase/auth';
// import { doc, getDoc, collection, query, orderBy, limit, onSnapshot } from 'firebase/firestore';
// import { db } from '../firebase'; // Import db from firebase
// import { useNavigate } from 'react-router-dom'; // Import useNavigate from react-router-dom

// function ProtectedComponent() {
//     const [userData, setUserData] = useState(null);
//     const [feedlots, setFeedlots] = useState([]);
//     const [selectedFeedlot, setSelectedFeedlot] = useState(null);
//     const [currentData, setCurrentData] = useState(null);
//     const [currentData2, setCurrentData2] = useState(null);
//     const [realtimeData, setRealtimeData] = useState(null);
//     const [unsubscribeRealtimeListener, setUnsubscribeRealtimeListener] = useState(null);
//     const [error, setError] = useState(null);
//     const navigate = useNavigate(); // Initialize navigate for redirection

//     useEffect(() => {
//         const fetchData = async () => {
//             const auth = getAuth();
//             const user = auth.currentUser;
//             if (user) {
//                 try {
//                     const userDocRef = doc(db, 'users', user.uid); // Adjust path as needed
//                     const userDocSnap = await getDoc(userDocRef);

//                     if (userDocSnap.exists()) {
//                         const userData = userDocSnap.data();
//                         const { Feedlots, ...otherUserData } = userData;
//                         setUserData(otherUserData);

//                         if (Feedlots && Array.isArray(Feedlots)) {
//                             const feedlotPromises = Feedlots.map(ref => getDoc(ref));
//                             const feedlotDocs = await Promise.all(feedlotPromises);

//                             const feedlotDataArray = feedlotDocs
//                                 .map(feedlotDoc => feedlotDoc.exists() ? feedlotDoc.data() : null)
//                                 .filter(data => data !== null);

//                             setFeedlots(feedlotDataArray);
//                         } else {
//                             setError('Feedlots field is missing or not an array');
//                         }
//                     } else {
//                         setError('User document not found');
//                     }
//                 } catch (err) {
//                     setError(err.message);
//                 }
//             } else {
//                 setError('No authenticated user');
//                 // Redirect to login if no authenticated user
//                 navigate('/login');
//             }
//         };

//         fetchData();
//     }, [navigate]);

//     const convertTimestamp = (timestamp) => {
//         if (!timestamp || !timestamp.seconds) {
//             return null;
//         }
//         const date = new Date(timestamp.seconds * 1000); // Convert seconds to milliseconds
//         return date.toLocaleString(); // Convert date to a readable string
//     };

//     const fetchCurrentData = async (sarCompID) => {
//         try {
//             const additionalDataRef = doc(db, sarCompID, 'CurrentData'); // Adjust to correct path
//             const additionalDataSnap = await getDoc(additionalDataRef);
//             if (additionalDataSnap.exists()) {
//                 return additionalDataSnap.data();
//             }
//             return null;
//         } catch (err) {
//             throw new Error(`Failed to fetch current data for ${sarCompID}: ${err.message}`);
//         }
//     };

//     const fetchCurrentDataTMRO = async (tMRID) => {
//         try {
//             const additionalTmroRef = doc(db, tMRID, 'CurrentData'); // Adjust to correct path
//             const additionalTmroSnap = await getDoc(additionalTmroRef);
//             if (additionalTmroSnap.exists()) {
//                 return additionalTmroSnap.data();
//             }
//             return null;
//         } catch (err) {
//             throw new Error(`Failed to fetch current data for ${tMRID}: ${err.message}`);
//         }
//     };

//     const handleFeedlotSelect = async (event) => {
//         const feedlotIndex = event.target.value;
//         const feedlot = feedlots[feedlotIndex];
//         setSelectedFeedlot(feedlot);

//         // Unsubscribe from previous realtime listener if it exists
//         if (unsubscribeRealtimeListener) {
//             console.log('Unsubscribing from previous realtime listener');
//             unsubscribeRealtimeListener();
//             setUnsubscribeRealtimeListener(null);
//         }

//         // Clear previous data
//         setCurrentData(null);
//         setCurrentData2(null);
//         setRealtimeData(null);

//         // Fetch data for the new feedlot
//         if (feedlot && feedlot.SarCompID) {
//             try {
//                 const data = await fetchCurrentData(feedlot.SarCompID);
//                 setCurrentData(data);
//                 setupRealtimeListener(feedlot.SarCompID);
//             } catch (err) {
//                 setError(err.message);
//             }
//         }

//         if (feedlot && feedlot.TMRID) {
//             try {
//                 const data2 = await fetchCurrentDataTMRO(feedlot.TMRID);
//                 setCurrentData2(data2);
//             } catch (err) {
//                 setError(err.message);
//             }
//         }
//     };

//     const setupRealtimeListener = (sarCompID) => {
//         const dataLoggingRef = collection(db, sarCompID, 'Archives', 'DataLogging');
//         const dataLoggingQuery = query(dataLoggingRef, orderBy('timeStamp', 'desc'), limit(1));

//         const unsubscribe = onSnapshot(dataLoggingQuery, (snapshot) => {
//             if (!snapshot.empty) {
//                 const doc = snapshot.docs[0];
//                 setRealtimeData(doc.data());
//             } else {
//                 setRealtimeData(null);
//             }
//         });

//         setUnsubscribeRealtimeListener(() => unsubscribe);
//     };

//     const handleLogout = async () => {
//         try {
//             const auth = getAuth();
//             await signOut(auth);
//             navigate('/login'); // Redirect to the login page after logout
//         } catch (err) {
//             setError('Failed to log out: ' + err.message);
//         }
//     };

//     const styles = {
//         container: {
//             fontFamily: 'Arial, sans-serif',
//             maxWidth: '800px',
//             margin: '0 auto',
//             padding: '20px',
//             borderRadius: '10px',
//             backgroundColor: '#f9f9f9',
//             boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
//         },
//         heading: {
//             textAlign: 'center',
//             color: '#333',
//         },
//         error: {
//             color: 'red',
//             textAlign: 'center',
//         },
//         dataBlock: {
//             margin: '20px 0',
//             padding: '10px',
//             border: '1px solid #ddd',
//             borderRadius: '5px',
//             backgroundColor: '#fff',
//         },
//         pre: {
//             whiteSpace: 'pre-wrap',
//             wordBreak: 'break-all',
//         },
//         feedlotSelect: {
//             display: 'flex',
//             flexDirection: 'column',
//             alignItems: 'center',
//         },
//         dropdown: {
//             margin: '10px',
//             padding: '10px',
//             cursor: 'pointer',
//             border: '1px solid #ccc',
//             borderRadius: '5px',
//         },
//         logoutButton: {
//             display: 'block',
//             margin: '20px auto',
//             padding: '10px 20px',
//             fontSize: '16px',
//             cursor: 'pointer',
//             border: 'none',
//             borderRadius: '5px',
//             backgroundColor: '#f44336',
//             color: '#fff',
//         },
//     };

//     return (
//         <div style={styles.container}>
//             <h1 style={styles.heading}>Protected Data</h1>
//             {error && <p style={styles.error}>Error: {error}</p>}
//             <button style={styles.logoutButton} onClick={handleLogout}>Logout</button>
//             {userData && (
//                 <div style={styles.dataBlock}>
//                     <h2>User Data: {userData.Name}</h2>
//                     <h4>Name: {userData.Name}</h4>
//                     <h4>Email: {userData.Email}</h4>
//                     <h4>Role: {userData.RoleTitle}</h4>
//                 </div>
//             )}
//             {feedlots.length > 0 && (
//                 <div style={styles.feedlotSelect}>
//                     <h2>Select a Feedlot:</h2>
//                     <select style={styles.dropdown} onChange={handleFeedlotSelect}>
//                         <option value="">-- Select a Feedlot --</option>
//                         {feedlots.map((feedlot, index) => (
//                             <option key={index} value={index}>
//                                 {feedlot.Name || `Feedlot ${index + 1}`}
//                             </option>
//                         ))}
//                     </select>
//                 </div>
//             )}
//             {selectedFeedlot && (
//                 <div style={styles.dataBlock}>
//                     <h2>Selected Feedlot: {selectedFeedlot.Name}</h2>
//                     {selectedFeedlot.SarCompID && <h4>SarComputer ID: {selectedFeedlot.SarCompID}</h4>}
//                     {selectedFeedlot.SarTimeID && <h4>SarTime ID: {selectedFeedlot.SarTimeID}</h4>}
//                     {selectedFeedlot.TMRID && <h4>TMRO ID: {selectedFeedlot.TMRID}</h4>}
//                 </div>
//             )}
//             {currentData && (
//                 <div style={styles.dataBlock}>
//                     <h2>SarComputer ID: {selectedFeedlot.SarCompID} <br />Current Data:</h2>
//                     <h4>Readable Time: {convertTimestamp(currentData.timeStamp)}</h4>
//                 </div>
//             )}
//             {currentData2 && (
//                 <div style={styles.dataBlock}>
//                     <h2>TMRO ID: {selectedFeedlot.TMRID} <br />Current Data:</h2>
//                     <h4>Readable Time: {convertTimestamp(currentData2.timeStamp)}</h4>
//                 </div>
//             )}
//             {realtimeData && (
//                 <div style={styles.dataBlock}>
//                     <h2>Real-Time Data Logging:</h2>
//                     <h4>Current Timestamp: {convertTimestamp(realtimeData.timeStamp)}</h4>
//                     <h3>Grain Summary:</h3>
//                     <h4>Grain Type: {realtimeData.GrainType}</h4>
//                     <h4>Grain Flow Rate (Lbs/Min): {realtimeData.LbsMin}</h4>
//                     <h4>Grain Today (Lbs): {realtimeData.GrainLbs}</h4>
//                     <h3>Moisture Summary:</h3>
//                     <h4>Incoming Moisture (%): {realtimeData.mInc}%</h4>
//                     <h4>Actual Moisture (%): {realtimeData.mAct}%</h4>
//                     <h4>Target Moisture (%): {realtimeData.mTarg}%</h4>
//                     <h4>Actual Water (GPM): {realtimeData.wAct}</h4>
//                     <h4>Target Water (GPM): {realtimeData.wTarg}%</h4>
//                     <h4>Water Variance (%): {realtimeData.wVar}%</h4>
//                     <h3><strong>SarTemp SG:</strong></h3>
//                     <h4><strong>SarTemp SG</strong> Tank Volume: {realtimeData.TankVolume}</h4>
//                     <h4><strong>SarTemp SG</strong> Rate (CC/Min): {realtimeData.SarTempCC}</h4>
//                 </div>
//             )}
//         </div>
//     );
// }

// export { ProtectedComponent };



// // starting to add some styling mainly the sidebar and navbar 
// import React, { useState, useEffect } from 'react';
// import { getAuth, signOut } from 'firebase/auth';
// import { doc, getDoc, collection, query, orderBy, limit, onSnapshot } from 'firebase/firestore';
// import { db } from '../firebase'; // Import db from firebase
// import { useNavigate } from 'react-router-dom'; // Import useNavigate from react-router-dom
// import Navbar from './Navbar'; // Import Navbar component
// import Sidebar from './Sidebar'; // Import Sidebar component
// import MainContent from './MainContent'; // Import MainContent component

// function ProtectedComponent() {
//     const [userData, setUserData] = useState(null);
//     const [feedlots, setFeedlots] = useState([]);
//     const [selectedFeedlot, setSelectedFeedlot] = useState(null);
//     const [currentData, setCurrentData] = useState(null);
//     const [currentData2, setCurrentData2] = useState(null);
//     const [realtimeData, setRealtimeData] = useState(null);
//     const [unsubscribeRealtimeListener, setUnsubscribeRealtimeListener] = useState(null);
//     const [error, setError] = useState(null);
//     const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth >= 768); // State for sidebar toggle
//     const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false); // State for sidebar collapse
//     const navigate = useNavigate(); // Initialize navigate for redirection

//     useEffect(() => {
//         const fetchData = async () => {
//             const auth = getAuth();
//             const user = auth.currentUser;
//             if (user) {
//                 try {
//                     const userDocRef = doc(db, 'users', user.uid); // Adjust path as needed
//                     const userDocSnap = await getDoc(userDocRef);

//                     if (userDocSnap.exists()) {
//                         const userData = userDocSnap.data();
//                         const { Feedlots, ...otherUserData } = userData;
//                         setUserData(otherUserData);

//                         if (Feedlots && Array.isArray(Feedlots)) {
//                             const feedlotPromises = Feedlots.map(ref => getDoc(ref));
//                             const feedlotDocs = await Promise.all(feedlotPromises);

//                             const feedlotDataArray = feedlotDocs
//                                 .map(feedlotDoc => feedlotDoc.exists() ? feedlotDoc.data() : null)
//                                 .filter(data => data !== null);

//                             setFeedlots(feedlotDataArray);
//                         } else {
//                             setError('Feedlots field is missing or not an array');
//                         }
//                     } else {
//                         setError('User document not found');
//                     }
//                 } catch (err) {
//                     setError(err.message);
//                 }
//             } else {
//                 setError('No authenticated user');
//                 // Redirect to login if no authenticated user
//                 navigate('/login');
//             }
//         };

//         fetchData();
//     }, [navigate]);

    

//     const convertTimestamp = (timestamp) => {
//         if (!timestamp || !timestamp.seconds) {
//             return null;
//         }
//         const date = new Date(timestamp.seconds * 1000); // Convert seconds to milliseconds
//         return date.toLocaleString(); // Convert date to a readable string
//     };

//     const fetchCurrentData = async (sarCompID) => {
//         try {
//             const additionalDataRef = doc(db, sarCompID, 'CurrentData'); // Adjust to correct path
//             const additionalDataSnap = await getDoc(additionalDataRef);
//             if (additionalDataSnap.exists()) {
//                 return additionalDataSnap.data();
//             }
//             return null;
//         } catch (err) {
//             throw new Error(`Failed to fetch current data for ${sarCompID}: ${err.message}`);
//         }
//     };

//     const fetchCurrentDataTMRO = async (tMRID) => {
//         try {
//             const additionalTmroRef = doc(db, tMRID, 'CurrentData'); // Adjust to correct path
//             const additionalTmroSnap = await getDoc(additionalTmroRef);
//             if (additionalTmroSnap.exists()) {
//                 return additionalTmroSnap.data();
//             }
//             return null;
//         } catch (err) {
//             throw new Error(`Failed to fetch current data for ${tMRID}: ${err.message}`);
//         }
//     };

//     const handleFeedlotSelect = async (event) => {
//         const feedlotIndex = event.target.value;
//         const feedlot = feedlots[feedlotIndex];
//         setSelectedFeedlot(feedlot);

//         // Unsubscribe from previous realtime listener if it exists
//         if (unsubscribeRealtimeListener) {
//             console.log('Unsubscribing from previous realtime listener');
//             unsubscribeRealtimeListener();
//             setUnsubscribeRealtimeListener(null);
//         }

//         // Clear previous data
//         setCurrentData(null);
//         setCurrentData2(null);
//         setRealtimeData(null);

//         // Fetch data for the new feedlot
//         if (feedlot && feedlot.SarCompID) {
//             try {
//                 const data = await fetchCurrentData(feedlot.SarCompID);
//                 setCurrentData(data);
//                 setupRealtimeListener(feedlot.SarCompID);
//             } catch (err) {
//                 setError(err.message);
//             }
//         }

//         if (feedlot && feedlot.TMRID) {
//             try {
//                 const data2 = await fetchCurrentDataTMRO(feedlot.TMRID);
//                 setCurrentData2(data2);
//             } catch (err) {
//                 setError(err.message);
//             }
//         }
//     };

//     const setupRealtimeListener = (sarCompID) => {
//         const dataLoggingRef = collection(db, sarCompID, 'Archives', 'DataLogging');
//         const dataLoggingQuery = query(dataLoggingRef, orderBy('timeStamp', 'desc'), limit(1));

//         const unsubscribe = onSnapshot(dataLoggingQuery, (snapshot) => {
//             if (!snapshot.empty) {
//                 const doc = snapshot.docs[0];
//                 setRealtimeData(doc.data());
//             } else {
//                 setRealtimeData(null);
//             }
//         });

//         setUnsubscribeRealtimeListener(() => unsubscribe);
//     };

//     const fetchWeelklyAveragesData = (sarCompID) => {
//         const weeklyDataRef = collection(db, sarCompID, 'Archives', 'DailyAvergaes');
//         const weeklyDataQuery = query(weeklyDataRef, orderBy('timeStamp', 'desc'), limit(7));
//     };

//     const handleLogout = async () => {
//         try {
//             const auth = getAuth();
//             await signOut(auth);
//             navigate('/login');
//         } catch (err) {
//             console.error('Failed to logout:', err);
//             setError('Failed to logout');
//         }
//     };

//     const toggleSidebar = () => {
//         setIsSidebarOpen(!isSidebarOpen);
//     };

//     const toggleCollapse = () => {
//         setIsSidebarCollapsed(!isSidebarCollapsed);
//     };

//     const styles = {
//         container: {
//             fontFamily: 'Arial, sans-serif',
            
//         },
//         // content: {
//         //     marginLeft: isSidebarCollapsed ? '64px' : '256px', // Adjusted for collapsible sidebar
//         //     transition: 'margin-left 0.3s ease-in-out', // Add smooth transition
//         // },
//         dataBlock: {
//             margin: '20px 0',
//             padding: '10px',
//             border: '1px solid #ddd',
//             borderRadius: '5px',
//             backgroundColor: '#fff',
//         },
//         pre: {
//             whiteSpace: 'pre-wrap',
//             wordBreak: 'break-all',
//         },
//         feedlotSelect: {
//             display: 'flex',
//             flexDirection: 'column',
//             alignItems: 'center',
//         },
//         dropdown: {
//             margin: '10px',
//             padding: '10px',
//             cursor: 'pointer',
//             border: '1px solid #ccc',
//             borderRadius: '5px',
//         },
//         error: {
//             color: 'red',
//             textAlign: 'center',
//         },
//     };

//     return (
//         <div style={styles.container}>
//             <Navbar toggleSidebar={toggleSidebar} />
//             <div className="flex">
//                 <Sidebar isOpen={isSidebarOpen} isCollapsed={isSidebarCollapsed} toggleSidebar={toggleSidebar} toggleCollapse={toggleCollapse} />
//                 <main className="flex-1 p-4" style={styles.content}>
//                     {error && <p style={styles.error}>Error: {error}</p>}
//                     {userData && (
//                         <div style={styles.dataBlock}>
//                             <h2>User Data: {userData.Name}</h2>
//                             <h4>Name: {userData.Name}</h4>
//                             <h4>Email: {userData.Email}</h4>
//                             <h4>Role: {userData.RoleTitle}</h4>
//                         </div>
//                     )}
//                     {feedlots.length > 0 && (
//                         <div style={styles.feedlotSelect}>
//                             <h2>Select a Feedlot:</h2>
//                             <select style={styles.dropdown} onChange={handleFeedlotSelect}>
//                                 <option value="">-- Select a Feedlot --</option>
//                                 {feedlots.map((feedlot, index) => (
//                                     <option key={index} value={index}>
//                                         {feedlot.Name || `Feedlot ${index + 1}`}
//                                     </option>
//                                 ))}
//                             </select>
//                         </div>
//                     )}
//                     {selectedFeedlot && (
//                         <div style={styles.dataBlock}>
//                             <h2>Selected Feedlot: {selectedFeedlot.Name}</h2>
//                             {selectedFeedlot.SarCompID && <h4>SarComputer ID: {selectedFeedlot.SarCompID}</h4>}
//                             {selectedFeedlot.SarTimeID && <h4>SarTime ID: {selectedFeedlot.SarTimeID}</h4>}
//                             {selectedFeedlot.TMRID && <h4>TMRO ID: {selectedFeedlot.TMRID}</h4>}
//                         </div>
//                     )}
//                     {currentData && (
//                         <div style={styles.dataBlock}>
//                             <h2>SarComputer ID: {selectedFeedlot.SarCompID} <br />Current Data:</h2>
//                             <h4>Readable Time: {convertTimestamp(currentData.timeStamp)}</h4>
//                         </div>
//                     )}
//                     {currentData2 && (
//                         <div style={styles.dataBlock}>
//                             <h2>TMRO ID: {selectedFeedlot.TMRID} <br />Current Data:</h2>
//                             <h4>Readable Time: {convertTimestamp(currentData2.timeStamp)}</h4>
//                         </div>
//                     )}
//                     {realtimeData && (
//                         <div style={styles.dataBlock}>
//                             <h2>Real-Time Data Logging:</h2>
//                             <h4>Current Timestamp: {convertTimestamp(realtimeData.timeStamp)}</h4>
//                             <h3>Grain Summary:</h3>
//                             <h4>Grain Type: {realtimeData.GrainType}</h4>
//                             <h4>Grain Flow Rate (Lbs/Min): {realtimeData.LbsMin}</h4>
//                             <h4>Grain Today (Lbs): {realtimeData.GrainLbs}</h4>
//                             <h3>Moisture Summary:</h3>
//                             <h4>Incoming Moisture (%): {realtimeData.mInc}%</h4>
//                             <h4>Actual Moisture (%): {realtimeData.mAct}%</h4>
//                             <h4>Target Moisture (%): {realtimeData.mTarg}%</h4>
//                             <h4>Actual Water (GPM): {realtimeData.wAct}</h4>
//                             <h4>Target Water (GPM): {realtimeData.wTarg}%</h4>
//                             <h4>Water Variance (%): {realtimeData.wVar}%</h4>
//                             <h3><strong>SarTemp SG:</strong></h3>
//                             <h4><strong>SarTemp SG</strong> Tank Volume: {realtimeData.TankVolume}</h4>
//                             <h4><strong>SarTemp SG</strong> Rate (CC/Min): {realtimeData.SarTempCC}</h4>
//                         </div>
//                     )}
//                     <MainContent />
//                 </main>
//             </div>
//         </div>
//     );
// }

// export { ProtectedComponent };




// // starting to add some styling mainly the sidebar and navbar 
// import React, { useState, useEffect } from 'react';
// import { getAuth, signOut } from 'firebase/auth';
// import { doc, getDoc, collection, query, orderBy, limit, onSnapshot } from 'firebase/firestore';
// import { db } from '../firebase'; // Import db from firebase
// import { useNavigate } from 'react-router-dom'; // Import useNavigate from react-router-dom
// import Navbar from './Navbar'; // Import Navbar component
// import Sidebar from './Sidebar'; // Import Sidebar component
// import MainContent from './MainContent'; // Import MainContent component

// function ProtectedComponent() {
//     const [userData, setUserData] = useState(null);
//     const [feedlots, setFeedlots] = useState([]);
//     const [selectedFeedlot, setSelectedFeedlot] = useState(null);
//     const [currentData, setCurrentData] = useState(null);
//     const [currentData2, setCurrentData2] = useState(null);
//     const [realtimeData, setRealtimeData] = useState(null);
//     const [unsubscribeRealtimeListener, setUnsubscribeRealtimeListener] = useState(null);
//     const [error, setError] = useState(null);
//     const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth >= 768); // State for sidebar toggle
//     const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false); // State for sidebar collapse
//     const navigate = useNavigate(); // Initialize navigate for redirection

//     useEffect(() => {
//         const fetchData = async () => {
//             const auth = getAuth();
//             const user = auth.currentUser;
//             if (user) {
//                 try {
//                     const userDocRef = doc(db, 'users', user.uid); // Adjust path as needed
//                     const userDocSnap = await getDoc(userDocRef);

//                     if (userDocSnap.exists()) {
//                         const userData = userDocSnap.data();
//                         const { Feedlots, ...otherUserData } = userData;
//                         setUserData(otherUserData);

//                         if (Feedlots && Array.isArray(Feedlots)) {
//                             const feedlotPromises = Feedlots.map(ref => getDoc(ref));
//                             const feedlotDocs = await Promise.all(feedlotPromises);

//                             const feedlotDataArray = feedlotDocs
//                                 .map(feedlotDoc => feedlotDoc.exists() ? feedlotDoc.data() : null)
//                                 .filter(data => data !== null);

//                             setFeedlots(feedlotDataArray);
//                         } else {
//                             setError('Feedlots field is missing or not an array');
//                         }
//                     } else {
//                         setError('User document not found');
//                     }
//                 } catch (err) {
//                     setError(err.message);
//                 }
//             } else {
//                 setError('No authenticated user');
//                 // Redirect to login if no authenticated user
//                 navigate('/login');
//             }
//         };

//         fetchData();
//     }, [navigate]);

    

//     const convertTimestamp = (timestamp) => {
//         if (!timestamp || !timestamp.seconds) {
//             return null;
//         }
//         const date = new Date(timestamp.seconds * 1000); // Convert seconds to milliseconds
//         return date.toLocaleString(); // Convert date to a readable string
//     };

//     const fetchCurrentData = async (sarCompID) => {
//         try {
//             const additionalDataRef = doc(db, sarCompID, 'CurrentData'); // Adjust to correct path
//             const additionalDataSnap = await getDoc(additionalDataRef);
//             if (additionalDataSnap.exists()) {
//                 return additionalDataSnap.data();
//             }
//             return null;
//         } catch (err) {
//             throw new Error(`Failed to fetch current data for ${sarCompID}: ${err.message}`);
//         }
//     };

//     const fetchCurrentDataTMRO = async (tMRID) => {
//         try {
//             const additionalTmroRef = doc(db, tMRID, 'CurrentData'); // Adjust to correct path
//             const additionalTmroSnap = await getDoc(additionalTmroRef);
//             if (additionalTmroSnap.exists()) {
//                 return additionalTmroSnap.data();
//             }
//             return null;
//         } catch (err) {
//             throw new Error(`Failed to fetch current data for ${tMRID}: ${err.message}`);
//         }
//     };

//     const handleFeedlotSelect = async (event) => {
//         const feedlotIndex = event.target.value;
//         const feedlot = feedlots[feedlotIndex];
//         setSelectedFeedlot(feedlot);

//         // Unsubscribe from previous realtime listener if it exists
//         if (unsubscribeRealtimeListener) {
//             console.log('Unsubscribing from previous realtime listener');
//             unsubscribeRealtimeListener();
//             setUnsubscribeRealtimeListener(null);
//         }

//         // Clear previous data
//         setCurrentData(null);
//         setCurrentData2(null);
//         setRealtimeData(null);

//         // Fetch data for the new feedlot
//         if (feedlot && feedlot.SarCompID) {
//             try {
//                 const data = await fetchCurrentData(feedlot.SarCompID);
//                 setCurrentData(data);
//                 setupRealtimeListener(feedlot.SarCompID);
//             } catch (err) {
//                 setError(err.message);
//             }
//         }

//         if (feedlot && feedlot.TMRID) {
//             try {
//                 const data2 = await fetchCurrentDataTMRO(feedlot.TMRID);
//                 setCurrentData2(data2);
//             } catch (err) {
//                 setError(err.message);
//             }
//         }
//     };

//     const setupRealtimeListener = (sarCompID) => {
//         const dataLoggingRef = collection(db, sarCompID, 'Archives', 'DataLogging');
//         const dataLoggingQuery = query(dataLoggingRef, orderBy('timeStamp', 'desc'), limit(1));

//         const unsubscribe = onSnapshot(dataLoggingQuery, (snapshot) => {
//             if (!snapshot.empty) {
//                 const doc = snapshot.docs[0];
//                 setRealtimeData(doc.data());
//             } else {
//                 setRealtimeData(null);
//             }
//         });

//         setUnsubscribeRealtimeListener(() => unsubscribe);
//     };

//     const fetchWeelklyAveragesData = (sarCompID) => {
//         const weeklyDataRef = collection(db, sarCompID, 'Archives', 'DailyAvergaes');
//         const weeklyDataQuery = query(weeklyDataRef, orderBy('timeStamp', 'desc'), limit(7));
//     };

//     const handleLogout = async () => {
//         try {
//             const auth = getAuth();
//             await signOut(auth);
//             navigate('/login');
//         } catch (err) {
//             console.error('Failed to logout:', err);
//             setError('Failed to logout');
//         }
//     };

//     const toggleSidebar = () => {
//         setIsSidebarOpen(!isSidebarOpen);
//     };

//     const toggleCollapse = () => {
//         setIsSidebarCollapsed(!isSidebarCollapsed);
//     };

//     const styles = {
//         container: {
//             display: 'flex',
//             height: '100vh',
//             overflow: 'hidden',
//             fontFamily: 'Arial, sans-serif',
//         },
//         content: {
//             flex: 1,
//             display: 'flex',
//             flexDirection: 'column',
//             overflow: 'hidden',
//         },
//         mainContent: {
//             flex: 1,
//             overflowY: 'auto',
//             padding: '1rem',
//         },
//         dataBlock: {
//             margin: '20px 0',
//             padding: '10px',
//             border: '1px solid #ddd',
//             borderRadius: '5px',
//             backgroundColor: '#fff',
//         },
//         pre: {
//             whiteSpace: 'pre-wrap',
//             wordBreak: 'break-all',
//         },
//         feedlotSelect: {
//             display: 'flex',
//             flexDirection: 'column',
//             alignItems: 'center',
//         },
//         dropdown: {
//             margin: '10px',
//             padding: '10px',
//             cursor: 'pointer',
//             border: '1px solid #ccc',
//             borderRadius: '5px',
//         },
//         error: {
//             color: 'red',
//             textAlign: 'center',
//         },
//     };

//     return (
//         <div style={styles.container}>
//             <Sidebar isOpen={isSidebarOpen} isCollapsed={isSidebarCollapsed} toggleSidebar={toggleSidebar} toggleCollapse={toggleCollapse} />
//             <div style={styles.content}>
//                 <Navbar toggleSidebar={toggleSidebar} />
//                 <main style={styles.mainContent}>
//                     {error && <p style={styles.error}>Error: {error}</p>}
//                     {userData && (
//                         <div style={styles.dataBlock}>
//                             <h2>User Data: {userData.Name}</h2>
//                             <h4>Name: {userData.Name}</h4>
//                             <h4>Email: {userData.Email}</h4>
//                             <h4>Role: {userData.RoleTitle}</h4>
//                         </div>
//                     )}
//                     {feedlots.length > 0 && (
//                         <div style={styles.feedlotSelect}>
//                             <h2>Select a Feedlot:</h2>
//                             <select style={styles.dropdown} onChange={handleFeedlotSelect}>
//                                 <option value="">-- Select a Feedlot --</option>
//                                 {feedlots.map((feedlot, index) => (
//                                     <option key={index} value={index}>
//                                         {feedlot.Name || `Feedlot ${index + 1}`}
//                                     </option>
//                                 ))}
//                             </select>
//                         </div>
//                     )}
//                     {selectedFeedlot && (
//                         <div style={styles.dataBlock}>
//                             <h2>Selected Feedlot: {selectedFeedlot.Name}</h2>
//                             {selectedFeedlot.SarCompID && <h4>SarComputer ID: {selectedFeedlot.SarCompID}</h4>}
//                             {selectedFeedlot.SarTimeID && <h4>SarTime ID: {selectedFeedlot.SarTimeID}</h4>}
//                             {selectedFeedlot.TMRID && <h4>TMRO ID: {selectedFeedlot.TMRID}</h4>}
//                         </div>
//                     )}
//                     {currentData && (
//                         <div style={styles.dataBlock}>
//                             <h2>SarComputer ID: {selectedFeedlot.SarCompID} <br />Current Data:</h2>
//                             <h4>Readable Time: {convertTimestamp(currentData.timeStamp)}</h4>
//                         </div>
//                     )}
//                     {currentData2 && (
//                         <div style={styles.dataBlock}>
//                             <h2>TMRO ID: {selectedFeedlot.TMRID} <br />Current Data:</h2>
//                             <h4>Readable Time: {convertTimestamp(currentData2.timeStamp)}</h4>
//                         </div>
//                     )}
//                     {realtimeData && (
//                         <div style={styles.dataBlock}>
//                             <h2>Real-Time Data Logging:</h2>
//                             <h4>Current Timestamp: {convertTimestamp(realtimeData.timeStamp)}</h4>
//                             <h3>Grain Summary:</h3>
//                             <h4>Grain Type: {realtimeData.GrainType}</h4>
//                             <h4>Grain Flow Rate (Lbs/Min): {realtimeData.LbsMin}</h4>
//                             <h4>Grain Today (Lbs): {realtimeData.GrainLbs}</h4>
//                             <h3>Moisture Summary:</h3>
//                             <h4>Incoming Moisture (%): {realtimeData.mInc}%</h4>
//                             <h4>Actual Moisture (%): {realtimeData.mAct}%</h4>
//                             <h4>Target Moisture (%): {realtimeData.mTarg}%</h4>
//                             <h4>Actual Water (GPM): {realtimeData.wAct}</h4>
//                             <h4>Target Water (GPM): {realtimeData.wTarg}%</h4>
//                             <h4>Water Variance (%): {realtimeData.wVar}%</h4>
//                             <h3><strong>SarTemp SG:</strong></h3>
//                             <h4><strong>SarTemp SG</strong> Tank Volume: {realtimeData.TankVolume}</h4>
//                             <h4><strong>SarTemp SG</strong> Rate (CC/Min): {realtimeData.SarTempCC}</h4>
//                         </div>
//                     )}
//                     <div style={styles.dataBlock}>
//                         <button onClick={handleLogout}>Logout</button>
//                     </div>
//                     <MainContent />
//                 </main>
//             </div>
//         </div>
//     );
// }

// export { ProtectedComponent };



// import React, { useState, useEffect } from 'react';
// import { getAuth, signOut } from 'firebase/auth';
// import { doc, getDoc, collection, query, orderBy, limit, onSnapshot } from 'firebase/firestore';
// import { db } from '../firebase'; // Import db from firebase
// import { useNavigate } from 'react-router-dom'; // Import useNavigate from react-router-dom
// import Navbar from './Navbar'; // Import Navbar component
// import Sidebar from './Sidebar'; // Import Sidebar component
// import MainContent from './MainContent'; // Import MainContent component

// function ProtectedComponent() {
//     const [userData, setUserData] = useState(null);
//     const [feedlots, setFeedlots] = useState([]);
//     const [selectedFeedlot, setSelectedFeedlot] = useState(null);
//     const [currentData, setCurrentData] = useState(null);
//     const [currentData2, setCurrentData2] = useState(null);
//     const [realtimeData, setRealtimeData] = useState(null);
//     const [unsubscribeRealtimeListener, setUnsubscribeRealtimeListener] = useState(null);
//     const [error, setError] = useState(null);
//     const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth >= 768); // State for sidebar toggle
//     const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false); // State for sidebar collapse
//     const navigate = useNavigate(); // Initialize navigate for redirection

//     useEffect(() => {
//         const fetchData = async () => {
//             const auth = getAuth();
//             const user = auth.currentUser;
//             if (user) {
//                 try {
//                     const userDocRef = doc(db, 'users', user.uid); // Adjust path as needed
//                     const userDocSnap = await getDoc(userDocRef);

//                     if (userDocSnap.exists()) {
//                         const userData = userDocSnap.data();
//                         const { Feedlots, ...otherUserData } = userData;
//                         setUserData(otherUserData);

//                         if (Feedlots && Array.isArray(Feedlots)) {
//                             const feedlotPromises = Feedlots.map(ref => getDoc(ref));
//                             const feedlotDocs = await Promise.all(feedlotPromises);

//                             const feedlotDataArray = feedlotDocs
//                                 .map(feedlotDoc => feedlotDoc.exists() ? feedlotDoc.data() : null)
//                                 .filter(data => data !== null);

//                             setFeedlots(feedlotDataArray);
//                         } else {
//                             setError('Feedlots field is missing or not an array');
//                         }
//                     } else {
//                         setError('User document not found');
//                     }
//                 } catch (err) {
//                     setError(err.message);
//                 }
//             } else {
//                 setError('No authenticated user');
//                 // Redirect to login if no authenticated user
//                 navigate('/login');
//             }
//         };

//         fetchData();
//     }, [navigate]);

    

//     const convertTimestamp = (timestamp) => {
//         if (!timestamp || !timestamp.seconds) {
//             return null;
//         }
//         const date = new Date(timestamp.seconds * 1000); // Convert seconds to milliseconds
//         return date.toLocaleString(); // Convert date to a readable string
//     };

//     const fetchCurrentData = async (sarCompID) => {
//         try {
//             const additionalDataRef = doc(db, sarCompID, 'CurrentData'); // Adjust to correct path
//             const additionalDataSnap = await getDoc(additionalDataRef);
//             if (additionalDataSnap.exists()) {
//                 return additionalDataSnap.data();
//             }
//             return null;
//         } catch (err) {
//             throw new Error(`Failed to fetch current data for ${sarCompID}: ${err.message}`);
//         }
//     };

//     const fetchCurrentDataTMRO = async (tMRID) => {
//         try {
//             const additionalTmroRef = doc(db, tMRID, 'CurrentData'); // Adjust to correct path
//             const additionalTmroSnap = await getDoc(additionalTmroRef);
//             if (additionalTmroSnap.exists()) {
//                 return additionalTmroSnap.data();
//             }
//             return null;
//         } catch (err) {
//             throw new Error(`Failed to fetch current data for ${tMRID}: ${err.message}`);
//         }
//     };

//     const handleFeedlotSelect = async (event) => {
//         const feedlotIndex = event.target.value;
//         const feedlot = feedlots[feedlotIndex];
//         setSelectedFeedlot(feedlot);

//         // Unsubscribe from previous realtime listener if it exists
//         if (unsubscribeRealtimeListener) {
//             console.log('Unsubscribing from previous realtime listener');
//             unsubscribeRealtimeListener();
//             setUnsubscribeRealtimeListener(null);
//         }

//         // Clear previous data
//         setCurrentData(null);
//         setCurrentData2(null);
//         setRealtimeData(null);

//         // Fetch data for the new feedlot
//         if (feedlot && feedlot.SarCompID) {
//             try {
//                 const data = await fetchCurrentData(feedlot.SarCompID);
//                 setCurrentData(data);
//                 setupRealtimeListener(feedlot.SarCompID);
//             } catch (err) {
//                 setError(err.message);
//             }
//         }

//         if (feedlot && feedlot.TMRID) {
//             try {
//                 const data2 = await fetchCurrentDataTMRO(feedlot.TMRID);
//                 setCurrentData2(data2);
//             } catch (err) {
//                 setError(err.message);
//             }
//         }
//     };

//     const setupRealtimeListener = (sarCompID) => {
//         const dataLoggingRef = collection(db, sarCompID, 'Archives', 'DataLogging');
//         const dataLoggingQuery = query(dataLoggingRef, orderBy('timeStamp', 'desc'), limit(1));

//         const unsubscribe = onSnapshot(dataLoggingQuery, (snapshot) => {
//             if (!snapshot.empty) {
//                 const doc = snapshot.docs[0];
//                 setRealtimeData(doc.data());
//             } else {
//                 setRealtimeData(null);
//             }
//         });

//         setUnsubscribeRealtimeListener(() => unsubscribe);
//     };

//     const fetchWeelklyAveragesData = (sarCompID) => {
//         const weeklyDataRef = collection(db, sarCompID, 'Archives', 'DailyAvergaes');
//         const weeklyDataQuery = query(weeklyDataRef, orderBy('timeStamp', 'desc'), limit(7));
//     };

//     const handleLogout = async () => {
//         try {
//             const auth = getAuth();
//             await signOut(auth);
//             navigate('/login');
//         } catch (err) {
//             console.error('Failed to logout:', err);
//             setError('Failed to logout');
//         }
//     };

//     const toggleSidebar = () => {
//         setIsSidebarOpen(!isSidebarOpen);
//     };

//     const toggleCollapse = () => {
//         setIsSidebarCollapsed(!isSidebarCollapsed);
//     };

//     const styles = {
//         container: {
//             textAlign: 'center',
//         },
//     // const styles = {
//     //     container: {
//     //         display: 'flex',
//     //         height: '100vh',
//     //         overflow: 'hidden',
//     //         fontFamily: 'Arial, sans-serif',
//     //     },
//         content: {
//             flex: 1,
//             display: 'flex',
//             flexDirection: 'column',
//             overflow: 'hidden',
//         },
//         mainContent: {
//             flex: 1,
//             overflowY: 'auto',
//             padding: '1rem',
//         },
//         dataBlock: {
//             margin: '20px 0',
//             padding: '10px',
//             border: '1px solid #ddd',
//             borderRadius: '5px',
//             backgroundColor: '#fff',
//         },
//         pre: {
//             whiteSpace: 'pre-wrap',
//             wordBreak: 'break-all',
//         },
//         feedlotSelect: {
//             display: 'flex',
//             flexDirection: 'column',
//             alignItems: 'center',
//         },
//         dropdown: {
//             margin: '10px',
//             padding: '10px',
//             cursor: 'pointer',
//             border: '1px solid #ccc',
//             borderRadius: '5px',
//         },
//         error: {
//             color: 'red',
//             textAlign: 'center',
//         },
//     };

//     return (
//         <div style={styles.container}>
//             {/* <Sidebar isOpen={isSidebarOpen} isCollapsed={isSidebarCollapsed} toggleSidebar={toggleSidebar} toggleCollapse={toggleCollapse} /> */}
//             <div style={styles.content}>
//                 {/* <Navbar toggleSidebar={toggleSidebar} /> */}
//                 <main style={styles.mainContent}>
//                     {error && <p style={styles.error}>Error: {error}</p>}
//                     {userData && (
//                         <div style={styles.dataBlock}>
//                             <h2>User Data: {userData.Name}</h2>
//                             <h4>Name: {userData.Name}</h4>
//                             <h4>Email: {userData.Email}</h4>
//                             <h4>Role: {userData.RoleTitle}</h4>
//                         </div>
//                     )}
//                     {feedlots.length > 0 && (
//                         <div style={styles.feedlotSelect}>
//                             <h2>Select a Feedlot:</h2>
//                             <select style={styles.dropdown} onChange={handleFeedlotSelect}>
//                                 <option value="">-- Select a Feedlot --</option>
//                                 {feedlots.map((feedlot, index) => (
//                                     <option key={index} value={index}>
//                                         {feedlot.Name || `Feedlot ${index + 1}`}
//                                     </option>
//                                 ))}
//                             </select>
//                         </div>
//                     )}
//                     {selectedFeedlot && (
//                         <div style={styles.dataBlock}>
//                             <h2>Selected Feedlot: {selectedFeedlot.Name}</h2>
//                             {selectedFeedlot.SarCompID && <h4>SarComputer ID: {selectedFeedlot.SarCompID}</h4>}
//                             {selectedFeedlot.SarTimeID && <h4>SarTime ID: {selectedFeedlot.SarTimeID}</h4>}
//                             {selectedFeedlot.TMRID && <h4>TMRO ID: {selectedFeedlot.TMRID}</h4>}
//                         </div>
//                     )}
//                     {currentData && (
//                         <div style={styles.dataBlock}>
//                             <h2>SarComputer ID: {selectedFeedlot.SarCompID} <br />Current Data:</h2>
//                             <h4>Readable Time: {convertTimestamp(currentData.timeStamp)}</h4>
//                         </div>
//                     )}
//                     {currentData2 && (
//                         <div style={styles.dataBlock}>
//                             <h2>TMRO ID: {selectedFeedlot.TMRID} <br />Current Data:</h2>
//                             <h4>Readable Time: {convertTimestamp(currentData2.timeStamp)}</h4>
//                         </div>
//                     )}
//                     {realtimeData && (
//                         <div style={styles.dataBlock}>
//                             <h2>Real-Time Data Logging:</h2>
//                             <h4>Current Timestamp: {convertTimestamp(realtimeData.timeStamp)}</h4>
//                             <h3>Grain Summary:</h3>
//                             <h4>Grain Type: {realtimeData.GrainType}</h4>
//                             <h4>Grain Flow Rate (Lbs/Min): {realtimeData.LbsMin}</h4>
//                             <h4>Grain Today (Lbs): {realtimeData.GrainLbs}</h4>
//                             <h3>Moisture Summary:</h3>
//                             <h4>Incoming Moisture (%): {realtimeData.mInc}%</h4>
//                             <h4>Actual Moisture (%): {realtimeData.mAct}%</h4>
//                             <h4>Target Moisture (%): {realtimeData.mTarg}%</h4>
//                             <h4>Actual Water (GPM): {realtimeData.wAct}</h4>
//                             <h4>Target Water (GPM): {realtimeData.wTarg}%</h4>
//                             <h4>Water Variance (%): {realtimeData.wVar}%</h4>
//                             <h3><strong>SarTemp SG:</strong></h3>
//                             <h4><strong>SarTemp SG</strong> Tank Volume: {realtimeData.TankVolume}</h4>
//                             <h4><strong>SarTemp SG</strong> Rate (CC/Min): {realtimeData.SarTempCC}</h4>
//                         </div>
//                     )}
//                     <div style={styles.dataBlock}>
//                         <button onClick={handleLogout}>Logout</button>
//                     </div>
//                     {/* <MainContent /> */}
//                 </main>
//             </div>
//         </div>
//     );
// }

// export { ProtectedComponent };



// // Before using a GlobalStateComponent
// import React, { useState, useEffect, useContext } from 'react';
// import '../index.css'
// // import { getAuth, signOut } from 'firebase/auth';
// // import { doc, getDoc, collection, query, orderBy, limit, onSnapshot } from 'firebase/firestore';
// // import { db } from '../firebase'; // Import db from firebase
// // import { useNavigate } from 'react-router-dom'; // Import useNavigate from react-router-dom
// import RealTimeGraph from './RealTimeGraph';
// import { GlobalStateContext } from './GlobalStateContext';
// import PercentageLiveGraph from './PercentageLiveGraph';
// import WaterChart from './WaterGraph';
// import MtargGraph from './MtargGraph';
// import MactGraph from './MactGraph';
// import WvarGraph from './WvarGraph';
// // import Navbar from './Navbar'; // Import Navbar component
// // import Sidebar from './Sidebar'; // Import Sidebar component
// // import MainContent from './MainContent'; // Import MainContent component

// function ProtectedComponent() {
//     // const [userData, setUserData] = useState(null);
//     // const [feedlots, setFeedlots] = useState([]);
//     // const [selectedFeedlot, setSelectedFeedlot] = useState(null);
//     // const [currentData, setCurrentData] = useState(null);
//     // const [currentData2, setCurrentData2] = useState(null);
//     // const [realtimeData, setRealtimeData] = useState(null);
//     // const [unsubscribeRealtimeListener, setUnsubscribeRealtimeListener] = useState(null);
//     // const [error, setError] = useState(null);
//     // const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth >= 768); // State for sidebar toggle
//     // const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false); // State for sidebar collapse
//     // const navigate = useNavigate(); // Initialize navigate for redirection

//     // useEffect(() => {
//     //     const fetchData = async () => {
//     //         const auth = getAuth();
//     //         const user = auth.currentUser;
//     //         if (user) {
//     //             try {
//     //                 const userDocRef = doc(db, 'users', user.uid); // Adjust path as needed
//     //                 const userDocSnap = await getDoc(userDocRef);

//     //                 if (userDocSnap.exists()) {
//     //                     const userData = userDocSnap.data();
//     //                     const { Feedlots, ...otherUserData } = userData;
//     //                     setUserData(otherUserData);

//     //                     if (Feedlots && Array.isArray(Feedlots)) {
//     //                         const feedlotPromises = Feedlots.map(ref => getDoc(ref));
//     //                         const feedlotDocs = await Promise.all(feedlotPromises);

//     //                         const feedlotDataArray = feedlotDocs
//     //                             .map(feedlotDoc => feedlotDoc.exists() ? feedlotDoc.data() : null)
//     //                             .filter(data => data !== null);

//     //                         setFeedlots(feedlotDataArray);
//     //                     } else {
//     //                         setError('Feedlots field is missing or not an array');
//     //                     }
//     //                 } else {
//     //                     setError('User document not found');
//     //                 }
//     //             } catch (err) {
//     //                 setError(err.message);
//     //             }
//     //         } else {
//     //             setError('No authenticated user');
//     //             // Redirect to login if no authenticated user
//     //             navigate('/login');
//     //         }
//     //     };

//     //     fetchData();
//     // }, [navigate]);

    

//     // const convertTimestamp = (timestamp) => {
//     //     if (!timestamp || !timestamp.seconds) {
//     //         return null;
//     //     }
//     //     const date = new Date(timestamp.seconds * 1000); // Convert seconds to milliseconds
//     //     return date.toLocaleString(); // Convert date to a readable string
//     // };

//     // const fetchCurrentData = async (sarCompID) => {
//     //     try {
//     //         const additionalDataRef = doc(db, sarCompID, 'CurrentData'); // Adjust to correct path
//     //         const additionalDataSnap = await getDoc(additionalDataRef);
//     //         if (additionalDataSnap.exists()) {
//     //             return additionalDataSnap.data();
//     //         }
//     //         return null;
//     //     } catch (err) {
//     //         throw new Error(`Failed to fetch current data for ${sarCompID}: ${err.message}`);
//     //     }
//     // };

//     // const fetchCurrentDataTMRO = async (tMRID) => {
//     //     try {
//     //         const additionalTmroRef = doc(db, tMRID, 'CurrentData'); // Adjust to correct path
//     //         const additionalTmroSnap = await getDoc(additionalTmroRef);
//     //         if (additionalTmroSnap.exists()) {
//     //             return additionalTmroSnap.data();
//     //         }
//     //         return null;
//     //     } catch (err) {
//     //         throw new Error(`Failed to fetch current data for ${tMRID}: ${err.message}`);
//     //     }
//     // };

//     // const handleFeedlotSelect = async (event) => {
//     //     const feedlotIndex = event.target.value;
//     //     const feedlot = feedlots[feedlotIndex];
//     //     setSelectedFeedlot(feedlot);

//     //     // Unsubscribe from previous realtime listener if it exists
//     //     if (unsubscribeRealtimeListener) {
//     //         console.log('Unsubscribing from previous realtime listener');
//     //         unsubscribeRealtimeListener();
//     //         setUnsubscribeRealtimeListener(null);
//     //     }

//     //     // Clear previous data
//     //     setCurrentData(null);
//     //     setCurrentData2(null);
//     //     setRealtimeData(null);

//     //     // Fetch data for the new feedlot
//     //     if (feedlot && feedlot.SarCompID) {
//     //         try {
//     //             const data = await fetchCurrentData(feedlot.SarCompID);
//     //             setCurrentData(data);
//     //             setupRealtimeListener(feedlot.SarCompID);
//     //         } catch (err) {
//     //             setError(err.message);
//     //         }
//     //     }

//     //     if (feedlot && feedlot.TMRID) {
//     //         try {
//     //             const data2 = await fetchCurrentDataTMRO(feedlot.TMRID);
//     //             setCurrentData2(data2);
//     //         } catch (err) {
//     //             setError(err.message);
//     //         }
//     //     }
//     // };

//     // const setupRealtimeListener = (sarCompID) => {
//     //     const dataLoggingRef = collection(db, sarCompID, 'Archives', 'DataLogging');
//     //     const dataLoggingQuery = query(dataLoggingRef, orderBy('timeStamp', 'desc'), limit(10));

//     //     const unsubscribe = onSnapshot(dataLoggingQuery, (snapshot) => {
//     //         if (!snapshot.empty) {
//     //             const doc = snapshot.docs[0];
//     //             setRealtimeData(doc.data());
//     //         } else {
//     //             setRealtimeData(null);
//     //         }
//     //     });

//     //     setUnsubscribeRealtimeListener(() => unsubscribe);
//     // };

//     // const fetchWeelklyAveragesData = (sarCompID) => {
//     //     const weeklyDataRef = collection(db, sarCompID, 'Archives', 'DailyAvergaes');
//     //     const weeklyDataQuery = query(weeklyDataRef, orderBy('timeStamp', 'desc'), limit(7));
//     // };

//     // const handleLogout = async () => {
//     //     try {
//     //         const auth = getAuth();
//     //         await signOut(auth);
//     //         navigate('/login');
//     //     } catch (err) {
//     //         console.error('Failed to logout:', err);
//     //         setError('Failed to logout');
//     //     }
//     // };

//     // const toggleSidebar = () => {
//     //     setIsSidebarOpen(!isSidebarOpen);
//     // };

//     // const toggleCollapse = () => {
//     //     setIsSidebarCollapsed(!isSidebarCollapsed);
//     // };
//     const {
//       userData,
//       feedlots,
//       selectedFeedlot,
//       currentData,
//       currentData2,
//       realtimeData,
//       error,
//       isSidebarOpen,
//       isSidebarCollapsed,
//       handleFeedlotSelect,
//       handleLogout,
//       toggleSidebar,
//       toggleCollapse,
//     } = useContext(GlobalStateContext);

//     const styles = {
//         container: {
//             textAlign: 'center',
//         },
//     // const styles = {
//     //     container: {
//     //         display: 'flex',
//     //         height: '100vh',
//     //         overflow: 'hidden',
//     //         fontFamily: 'Arial, sans-serif',
//     //     },
//         content: {
//             flex: 1,
//             display: 'flex',
//             flexDirection: 'column',
//             overflow: 'hidden',
//         },
//         mainContent: {
//             flex: 1,
//             overflowY: 'auto',
//             padding: '1rem',
//         },
//         dataBlock: {
//             margin: '20px 0',
//             padding: '10px',
//             border: '1px solid #ddd',
//             borderRadius: '5px',
//             backgroundColor: '#fff',
//         },
//         pre: {
//             whiteSpace: 'pre-wrap',
//             wordBreak: 'break-all',
//         },
//         feedlotSelect: {
//             display: 'flex',
//             flexDirection: 'column',
//             textAlign: 'center',
//             // alignItems: 'center',
//         },
//         dropdown: {
//             margin: '10px',
//             padding: '10px',
//             cursor: 'pointer',
//             border: '1px solid #ccc',
//             borderRadius: '5px',
//             textAlign: 'center',
//         },
//         error: {
//             color: 'red',
//             textAlign: 'center',
//         },
//     };

//     return (
//         // <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 bg-gray-400 rounded-lg h-max p-3">
//         //         <div className="col-span-2 md:col-span-2 lg:col-span-4 bg-gradient-to-r from-blue-500 to-indigo-600 p-6 rounded-lg shadow-lg text-white" style={{backgroundImage: 'linear-gradient(10deg, rgba(68,29,7,1) 0%, rgba(176,115,53,1) 59%, rgba(255,179,56,1) 100%)'}}>
//         // <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between">
//         //     {userData && (
//         // <div>
//         //         <h1 className="text-3xl font-bold mb-2 lg:mb-0">Welcome, {userData.Name}!</h1>
//         //         <p className="text-lg">This is your dashboard where you can monitor real-time data. Select a feedlot to get started.</p>
                
//         // </div>
//         //     )}
//         // <div className="mt-4 lg:mt-0">
//         //   <button className="bg-white text-blue-500 px-4 py-2 rounded-md shadow-md hover:bg-gray-100 transition">
//         //     Learn More
//         //   </button>
//         // </div>
//         // </div>
//         // </div>
//         //     {feedlots.length > 0 && (
//         //     <div className="col-span-2 lg:col-span-4 rounded-lg ... bg-slate-600">02
//         //          <div style={styles.feedlotSelect}>
//         //              <h2>Select a Feedlot:</h2>
//         //              <select style={styles.dropdown} onChange={handleFeedlotSelect}>
//         //                  <option value="">-- Select a Feedlot --</option>
//         //                  {feedlots.map((feedlot, index) => (
//         //                      <option key={index} value={index}>
//         //                          {feedlot.Name || `Feedlot ${index + 1}`}
//         //                      </option>
//         //                  ))}
//         //              </select>
//         //          </div>
//         //     </div>
//         //      )}
//         //      {realtimeData && (
//         //     <div className="grid grid-cols-2 gap-2 rounded-lg col-span-2 ... bg-slate-600 p-2">
//         //         <div className="grid grid-cols-1 rounded-lg ... bg-slate-800 text-center text-white">
//         //             <div className='self-center'>
//         //                 <span className=''>Grain Type: {realtimeData.GrainType}</span>
//         //             </div>
//         //         </div>
//         //         <div className="grid grid-cols-1 rounded-lg ... bg-slate-800 text-center text-white">
//         //             <div className='self-center'>
//         //                 <span>Grain Today: {realtimeData.GrainLbs} Lbs</span>
//         //             </div>

//         //         </div>
//         //         <div className="grid col-span-2 grid-cols-1 rounded-lg ... bg-slate-800 text-center text-white p-2">
//         //         <RealTimeGraph realtimeData={realtimeData} />


//         //         </div>
//         //         {/* <div className="grid grid-cols-1 rounded-lg ... bg-slate-800 text-center text-white">06

//         //         </div> */}
//         //     </div>

//         //      )}
//         //     {realtimeData && (
//         //     <div className="grid grid-cols-2 md:grid-cols-4 gap-2 rounded-lg col-span-2 ... bg-slate-600 p-2">
//         //         <div className="grid grid-cols-1 rounded-lg ... bg-slate-800 text-center text-white p-1">
//         //         <MtargGraph percentageData={realtimeData} />
//         //         </div>
//         //         <div className="grid grid-cols-1 rounded-lg ... bg-slate-800 text-center text-white p-1">
//         //         <MactGraph percentageData={realtimeData} />
//         //         </div>
//         //         <div className="grid grid-cols-1 rounded-lg ... bg-slate-800 text-center text-white p-1">
//         //         <PercentageLiveGraph percentageData={realtimeData} />
//         //         </div>
//         //         <div className="grid grid-cols-1 rounded-lg ... bg-slate-800 text-center text-white p-1">
//         //         <WvarGraph percentageData={realtimeData} />

//         //         </div>
//         //         <div className="grid grid-cols-1 col-span-2 md:col-span-4 gap-2 rounded-lg ... bg-slate-800 text-center text-white p-2">
//         //             <WaterChart realtimeData={realtimeData} />
//         //         </div>

//         //     </div>
//         //     )}
//         //     <div className="rounded-lg ... bg-slate-600 h-64">
//         //         03

//         //     </div>
//         //     <div className="rounded-lg ... bg-slate-600">06</div>
//         //     <div className="rounded-lg col-span-2 ... bg-slate-600">
//         //                  <div style={styles.dataBlock}>
//         //                <button onClick={handleLogout}>Logout</button>
//         //              </div>
//         //     </div>
//         // </div>



// <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 bg-gray-900 h-max p-3">
//   {/* Welcome Section */}
//   <div className="col-span-2 md:col-span-2 lg:col-span-4 bg-gradient-to-r from-#2f4858 to-#33658a p-6 rounded-lg shadow-xl text-white" style={{ backgroundImage: 'linear-gradient(10deg, #2f4858 0%, #33658a 50%, #86bbd8 100%)' }}>
//     <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between">
//       {userData && (
//         <div>
//           <h1 className="text-3xl font-bold mb-2 lg:mb-0">Welcome, {userData.Name}!</h1>
//           <p className="text-lg">This is your dashboard where you can monitor real-time data. Select a feedlot to get started.</p>
//         </div>
//       )}
//       <div className="mt-4 lg:mt-0 shadow-3xl rounded-lg">
//         <button className="bg-[#33658a] text-#2f4858 px-4 py-2 rounded-md shadow-xl hover:bg-[#2f4858] transition">
//           Learn More
//         </button>
//       </div>
//     </div>
//   </div>

//   {/* Feedlot Selection */}
//   {feedlots.length > 0 && (
//     <div className="col-span-2 lg:col-span-4 bg-slate-400 bg-opacity-50 backdrop-filter backdrop-blur-lg p-4 rounded-lg shadow-3xl">
//       <h2 className="text-xl font-semibold text-gray-100 mb-4 ">Select a Feedlot:</h2>
//       <select className="w-full p-2 rounded-md bg-slate-100 text-gray-700 shadow-3xl" onChange={handleFeedlotSelect}>
//         <option value="">-- Select a Feedlot --</option>
//         {feedlots.map((feedlot, index) => (
//           <option key={index} value={index}>
//             {feedlot.Name || `Feedlot ${index + 1}`}
//           </option>
//         ))}
//       </select>
//     </div>
//   )}

//   {/* Real-Time Data */}
//   {realtimeData && (
//     <div className="grid grid-cols-2 gap-4 col-span-2 lg:col-span-4 bg-opacity-50 backdrop-filter backdrop-blur-lg bg-slate-400 p-4 rounded-lg shadow-3xl">
//       <div className="bg-slate-200 lg:text-xl font-bold p-4 rounded-lg text-center text-gray-700 shadow-3xl">
//         <span>Grain Type: {realtimeData.GrainType}</span>
//       </div>
//       <div className="bg-slate-200 lg:text-xl font-bold p-4 rounded-lg text-center text-gray-700 shadow-3xl">
//         <span>Grain Today: {realtimeData.GrainLbs} Lbs</span>
//       </div>
//       <div className="col-span-2 bg-slate-800 p-4 rounded-lg text-center text-slate-200 shadow-3xl">
//         <RealTimeGraph realtimeData={realtimeData} />
//       </div>
//     </div>
//   )}

//   {/* Additional Graphs */}
//   {realtimeData && (
//     <div className="grid grid-cols-2 md:grid-cols-4 gap-4 col-span-2 lg:col-span-4 bg-opacity-50 backdrop-filter backdrop-blur-lg bg-slate-400 p-4 rounded-lg shadow-2xl">
//       <div className="bg-[#98C7FF] p-4 rounded-lg text-center text-gray-700 shadow-3xl">
//         <MtargGraph percentageData={realtimeData} />
//       </div>
//       <div className="bg-[#C4FFFF] p-4 rounded-lg text-center text-gray-700 shadow-3xl">
//         <MactGraph percentageData={realtimeData} />
//       </div>
//       <div className="bg-[#E3E6FF] p-4 rounded-lg text-center text-gray-700 shadow-3xl">
//         <PercentageLiveGraph percentageData={realtimeData} />
//       </div>
//       <div className="bg-[#FFE4EB] p-4 rounded-lg text-center text-gray-700 shadow-3xl">
//         <WvarGraph percentageData={realtimeData} />
//       </div>
//       <div className="col-span-2 md:col-span-4 bg-slate-800 p-4 rounded-lg text-center text-slate-200 shadow-3xl">
//         <WaterChart realtimeData={realtimeData} />
//       </div>
//     </div>
//   )}

//   {/* Placeholder Sections */}
//   <div className="bg-slate-200 p-4 rounded-lg shadow-2xl h-64 flex items-center justify-center text-gray-700">
//     Placeholder Content
//   </div>
//   <div className="bg-slate-200 p-4 rounded-lg shadow-2xl flex items-center justify-center text-gray-700">
//     Placeholder Content
//   </div>

//   {/* Logout Button */}
//   <div className="col-span-2 bg-slate-400 p-4 rounded-lg shadow-2xl flex items-center justify-center">
//     <button className="bg-slate-600 text-white px-4 py-2 rounded-md shadow-md hover:bg-[#e85410] transition" onClick={handleLogout}>
//       Logout
//     </button>
//   </div>
// </div>






//         // <div style={styles.container}>
//         //     {/* <Sidebar isOpen={isSidebarOpen} isCollapsed={isSidebarCollapsed} toggleSidebar={toggleSidebar} toggleCollapse={toggleCollapse} /> */}
//         //     <div style={styles.content}>
//         //         {/* <Navbar toggleSidebar={toggleSidebar} /> */}
//         //         <main style={styles.mainContent}>
//         //             {error && <p style={styles.error}>Error: {error}</p>}
//         //             {userData && (
//         //                 <div style={styles.dataBlock}>
//         //                     <h2>User Data: {userData.Name}</h2>
//         //                     <h4>Name: {userData.Name}</h4>
//         //                     <h4>Email: {userData.Email}</h4>
//         //                     <h4>Role: {userData.RoleTitle}</h4>
//         //                 </div>
//         //             )}
//         //             {feedlots.length > 0 && (
//         //                 <div style={styles.feedlotSelect}>
//         //                     <h2>Select a Feedlot:</h2>
//         //                     <select style={styles.dropdown} onChange={handleFeedlotSelect}>
//         //                         <option value="">-- Select a Feedlot --</option>
//         //                         {feedlots.map((feedlot, index) => (
//         //                             <option key={index} value={index}>
//         //                                 {feedlot.Name || `Feedlot ${index + 1}`}
//         //                             </option>
//         //                         ))}
//         //                     </select>
//         //                 </div>
//         //             )}
//         //             {selectedFeedlot && (
//         //                 <div style={styles.dataBlock}>
//         //                     <h2>Selected Feedlot: {selectedFeedlot.Name}</h2>
//         //                     {selectedFeedlot.SarCompID && <h4>SarComputer ID: {selectedFeedlot.SarCompID}</h4>}
//         //                     {selectedFeedlot.SarTimeID && <h4>SarTime ID: {selectedFeedlot.SarTimeID}</h4>}
//         //                     {selectedFeedlot.TMRID && <h4>TMRO ID: {selectedFeedlot.TMRID}</h4>}
//         //                 </div>
//         //             )}
//         //             {currentData && (
//         //                 <div style={styles.dataBlock}>
//         //                     <h2>SarComputer ID: {selectedFeedlot.SarCompID} <br />Current Data:</h2>
//         //                     <h4>Readable Time: {convertTimestamp(currentData.timeStamp)}</h4>
//         //                 </div>
//         //             )}
//         //             {currentData2 && (
//         //                 <div style={styles.dataBlock}>
//         //                     <h2>TMRO ID: {selectedFeedlot.TMRID} <br />Current Data:</h2>
//         //                     <h4>Readable Time: {convertTimestamp(currentData2.timeStamp)}</h4>
//         //                 </div>
//         //             )}
//         //             {realtimeData && (
//         //                 <div style={styles.dataBlock}>
//         //                     <h2>Real-Time Data Logging:</h2>
//         //                     <h4>Current Timestamp: {convertTimestamp(realtimeData.timeStamp)}</h4>
//         //                     <h3>Grain Summary:</h3>
//         //                     <h4>Grain Type: {realtimeData.GrainType}</h4>
//         //                     <h4>Grain Flow Rate (Lbs/Min): {realtimeData.LbsMin}</h4>
//         //                     <h4>Grain Today (Lbs): {realtimeData.GrainLbs}</h4>
//         //                     <h3>Moisture Summary:</h3>
//         //                     <h4>Incoming Moisture (%): {realtimeData.mInc}%</h4>
//         //                     <h4>Actual Moisture (%): {realtimeData.mAct}%</h4>
//         //                     <h4>Target Moisture (%): {realtimeData.mTarg}%</h4>
//         //                     <h4>Actual Water (GPM): {realtimeData.wAct}</h4>
//         //                     <h4>Target Water (GPM): {realtimeData.wTarg}%</h4>
//         //                     <h4>Water Variance (%): {realtimeData.wVar}%</h4>
//         //                     <h3><strong>SarTemp SG:</strong></h3>
//         //                     <h4><strong>SarTemp SG</strong> Tank Volume: {realtimeData.TankVolume}</h4>
//         //                     <h4><strong>SarTemp SG</strong> Rate (CC/Min): {realtimeData.SarTempCC}</h4>
//         //                 </div>
//         //             )}
//         //             <div style={styles.dataBlock}>
//         //                 <button onClick={handleLogout}>Logout</button>
//         //             </div>
//         //             {/* <MainContent /> */}
//         //         </main>
//         //     </div>
//         // </div>
//     );
// }

// export { ProtectedComponent };





import React, { useContext } from 'react';
import '../index.css'
import { Link } from 'react-router-dom';
import RealTimeGraph from './RealTimeGraph';
import { GlobalStateContext } from './GlobalStateContext';
import PercentageLiveGraph from './PercentageLiveGraph';
import WaterChart from './WaterGraph';
import MtargGraph from './MtargGraph';
import MactGraph from './MactGraph';
import WvarGraph from './WvarGraph';
import SarTempRate from './SarTempRate';
import SarTempVolume from './SarTempVolume';
import LoadingAnimation from './LoadingAnimation';
import DateTimeStamp from './DataTimeStamp';
import AutoManualIndicator from './AutoManualIndicator';

function ProtectedComponent() {
    const {
      userData,
      feedlots,
      selectedFeedlot,
      realtimeData,
      handleFeedlotSelect,
      noDataAlertRealTime,
      isLoading,
    } = useContext(GlobalStateContext);

    console.log(selectedFeedlot)
    

    const styles = {
        container: {
            textAlign: 'center',
        },
        content: {
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
        },
        mainContent: {
            flex: 1,
            overflowY: 'auto',
            padding: '1rem',
        },
        dataBlock: {
            margin: '20px 0',
            padding: '10px',
            border: '1px solid #ddd',
            borderRadius: '5px',
            backgroundColor: '#fff',
        },
        pre: {
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-all',
        },
        feedlotSelect: {
            display: 'flex',
            flexDirection: 'column',
            textAlign: 'center',
            // alignItems: 'center',
        },
        dropdown: {
            margin: '10px',
            padding: '10px',
            cursor: 'pointer',
            border: '1px solid #ccc',
            borderRadius: '5px',
            textAlign: 'center',
        },
        error: {
            color: 'red',
            textAlign: 'center',
        },
    };

    return (
<div className="grid grid-cols-2 lg:grid-cols-4 gap-6 bg-gray-900 h-max p-3 items-center">
  {/* Welcome Section */}
  <div className="col-span-2 md:col-span-2 lg:col-span-4 bg-gradient-to-r from-#2f4858 to-#33658a p-6 rounded-lg shadow-xl text-white" style={{ backgroundImage: 'linear-gradient(10deg, #2f4858 0%, #33658a 50%, #86bbd8 100%)' }}>
    <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between">
      {userData && (
        <div>
          <h1 className="text-3xl font-bold mb-2 lg:mb-0">Welcome, {userData.Name}!</h1>
          <p className="text-lg">This is your dashboard where you can monitor real-time data. Select a feedlot to get started.</p>
        </div>
      )}
      <div className="mt-4 lg:mt-0 shadow-3xl rounded-lg">
      <Link to="/about">
      <button className="bg-[#33658a] text-#2f4858 px-4 py-2 rounded-md shadow-xl hover:bg-[#2f4858] transition">
        Learn More
      </button>
    </Link>
      </div>
    </div>
  </div>

  {/* Feedlot Selection */}
  {feedlots.length > 0 && (
    <div className="col-span-2 lg:col-span-4 bg-slate-400 bg-opacity-50 backdrop-filter backdrop-blur-lg p-4 rounded-lg shadow-3xl">
      <h2 className="text-xl font-semibold text-gray-100 mb-4 ">Select a Feedlot:</h2>
      <select
      className="cursor-pointer w-full p-2 rounded-md bg-slate-100 text-gray-700 shadow-3xl" 
      onChange={handleFeedlotSelect}
      value={selectedFeedlot ? feedlots.findIndex(feedlot => (feedlot.SarCompID === selectedFeedlot.SarCompID && feedlot.TMRID === selectedFeedlot.TMRID)) : ''}
    >
        <option value="">-- Select a Feedlot --</option>
        {feedlots.map((feedlot, index) => (
          <option key={index} value={index}>
            {feedlot.Name || `Feedlot ${index + 1}`}
          </option>
        ))}
      </select>
    </div>
  )}

        {/* Alert for No Feedlot Selected */}
        {!selectedFeedlot && (
      <div className="col-span-2 md:col-span-3 lg:col-span-4 bg-indigo-200 text-blue-600 p-4 rounded-lg shadow-3xl flex items-center">
        <svg className='className="w-6 h-6 text-gray-100 mr-2' viewBox="0 0 24 24" version="1.1"  fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <title>information_fill</title> <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="System" transform="translate(-672.000000, -48.000000)" fill-rule="nonzero"> <g id="information_fill" transform="translate(672.000000, 48.000000)"> <path d="M24,0 L24,24 L0,24 L0,0 L24,0 Z M12.5934901,23.257841 L12.5819402,23.2595131 L12.5108777,23.2950439 L12.4918791,23.2987469 L12.4918791,23.2987469 L12.4767152,23.2950439 L12.4056548,23.2595131 C12.3958229,23.2563662 12.3870493,23.2590235 12.3821421,23.2649074 L12.3780323,23.275831 L12.360941,23.7031097 L12.3658947,23.7234994 L12.3769048,23.7357139 L12.4804777,23.8096931 L12.4953491,23.8136134 L12.4953491,23.8136134 L12.5071152,23.8096931 L12.6106902,23.7357139 L12.6232938,23.7196733 L12.6232938,23.7196733 L12.6266527,23.7031097 L12.609561,23.275831 C12.6075724,23.2657013 12.6010112,23.2592993 12.5934901,23.257841 L12.5934901,23.257841 Z M12.8583906,23.1452862 L12.8445485,23.1473072 L12.6598443,23.2396597 L12.6498822,23.2499052 L12.6498822,23.2499052 L12.6471943,23.2611114 L12.6650943,23.6906389 L12.6699349,23.7034178 L12.6699349,23.7034178 L12.678386,23.7104931 L12.8793402,23.8032389 C12.8914285,23.8068999 12.9022333,23.8029875 12.9078286,23.7952264 L12.9118235,23.7811639 L12.8776777,23.1665331 C12.8752882,23.1545897 12.8674102,23.1470016 12.8583906,23.1452862 L12.8583906,23.1452862 Z M12.1430473,23.1473072 C12.1332178,23.1423925 12.1221763,23.1452606 12.1156365,23.1525954 L12.1099173,23.1665331 L12.0757714,23.7811639 C12.0751323,23.7926639 12.0828099,23.8018602 12.0926481,23.8045676 L12.108256,23.8032389 L12.3092106,23.7104931 L12.3186497,23.7024347 L12.3186497,23.7024347 L12.3225043,23.6906389 L12.340401,23.2611114 L12.337245,23.2485176 L12.337245,23.2485176 L12.3277531,23.2396597 L12.1430473,23.1473072 Z" id="MingCute" fill-rule="nonzero"> </path> <path d="M12,2 C17.5228,2 22,6.47715 22,12 C22,17.5228 17.5228,22 12,22 C6.47715,22 2,17.5228 2,12 C2,6.47715 6.47715,2 12,2 Z M11.99,10 L11,10 C10.4477,10 10,10.4477 10,11 C10,11.51285 10.386027,11.9355092 10.8833761,11.9932725 L11,12 L11,16.99 C11,17.5106133 11.3938293,17.9392373 11.8999333,17.9940734 L12.01,18 L12.5,18 C13.0523,18 13.5,17.5523 13.5,17 C13.5,16.6710222 13.3411062,16.3791012 13.0958694,16.1968582 L13,16.1338 L13,11.01 C13,10.4893867 12.6060836,10.0607627 12.1000493,10.0059266 L11.99,10 Z M12,7 C11.4477,7 11,7.44772 11,8 C11,8.55228 11.4477,9 12,9 C12.5523,9 13,8.55228 13,8 C13,7.44772 12.5523,7 12,7 Z" id="形状" fill="#2b73da"> </path> </g> </g> </g> </g></svg>
        Select a Feedlot to view data.
      </div>
      )}

      {/* Real-Time Data */}
      {selectedFeedlot && isLoading && selectedFeedlot.SarBatchID !== "2" ? (
                <div className="col-span-2 lg:col-span-4 m-10 flex justify-center items-center">
                <LoadingAnimation />
              </div>
      ) : selectedFeedlot && realtimeData && selectedFeedlot.SarBatchID !== "2" ? (
        <>
          <DateTimeStamp realTimeData={realtimeData}/>
          <div className="grid grid-cols-2 gap-4 col-span-2 lg:col-span-4 bg-opacity-50 backdrop-filter backdrop-blur-lg bg-slate-400 p-4 rounded-lg shadow-3xl">
            <div className="bg-slate-200 lg:text-xl font-bold p-4 rounded-lg text-center text-gray-700 shadow-3xl">
              <span>Water Today: {realtimeData.WaterGals} Gallons</span>
            </div>
            <div className="bg-slate-200 lg:text-xl font-bold p-4 rounded-lg text-center text-gray-700 shadow-3xl">
              <span>Grain Today: {Math.floor(realtimeData.GrainLbs/2000)} Tons</span>
            </div>
            <AutoManualIndicator realTimeData={realtimeData}/>
            <div className="col-span-2 bg-slate-800 p-4 rounded-lg text-center text-slate-700 shadow-3xl">
              <RealTimeGraph realtimeData={realtimeData} />
            </div>
          </div>

          {/* Additional Graphs */ }
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 col-span-2 lg:col-span-4 bg-opacity-50 backdrop-filter backdrop-blur-lg bg-slate-400 p-4 rounded-lg shadow-2xl">
            <div className="bg-[#98C7FF] p-4 rounded-lg text-center text-gray-700 shadow-3xl">
              <MtargGraph percentageData={realtimeData} />
            </div>
            <div className="bg-[#C4FFFF] p-4 rounded-lg text-center text-gray-700 shadow-3xl">
              <MactGraph percentageData={realtimeData} />
            </div>
            <div className="bg-[#E3E6FF] p-4 rounded-lg text-center text-gray-700 shadow-3xl">
              <PercentageLiveGraph percentageData={realtimeData} />
            </div>
            <div className="bg-[#FFE4EB] p-4 rounded-lg text-center text-gray-700 shadow-3xl">
              <WvarGraph percentageData={realtimeData} />
            </div>
            <div className="col-span-2 md:col-span-4 bg-slate-800 p-4 rounded-lg text-center text-slate-700 shadow-3xl">
              <WaterChart realtimeData={realtimeData} />
            </div>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-2 gap-4 col-span-2 lg:col-span-4 bg-opacity-50 backdrop-filter backdrop-blur-lg bg-slate-400 p-4 rounded-lg shadow-2xl">
            <div className="bg-[#F8E3C0] p-4 text-center rounded-lg shadow-2xl flex items-center justify-center text-gray-700">
              <SarTempVolume percentageData={realtimeData} />
            </div>
            <div className="bg-[#F8E3C0] p-4 text-center rounded-lg shadow-2xl flex items-center justify-center text-gray-700">
              <SarTempRate percentageData={realtimeData} />
            </div>
          </div>
        </>
      ) : (
        noDataAlertRealTime && selectedFeedlot.SarBatchID !== "2" && (
        <div className="col-span-2 md:col-span-3 lg:col-span-4 bg-red-200 text-red-700 p-4 rounded-lg shadow-3xl flex items-center">
          <svg className='className="w-6 h-6 text-gray-100 mr-2' viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <title>alert_fill</title> <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="System" transform="translate(-286.000000, -240.000000)"> <g id="alert_fill" transform="translate(286.000000, 240.000000)"> <path d="M24,0 L24,24 L0,24 L0,0 L24,0 Z M12.5934901,23.257841 L12.5819402,23.2595131 L12.5108777,23.2950439 L12.4918791,23.2987469 L12.4918791,23.2987469 L12.4767152,23.2950439 L12.4056548,23.2595131 C12.3958229,23.2563662 12.3870493,23.2590235 12.3821421,23.2649074 L12.3780323,23.275831 L12.360941,23.7031097 L12.3658947,23.7234994 L12.3769048,23.7357139 L12.4804777,23.8096931 L12.4953491,23.8136134 L12.4953491,23.8136134 L12.5071152,23.8096931 L12.6106902,23.7357139 L12.6232938,23.7196733 L12.6232938,23.7196733 L12.6266527,23.7031097 L12.609561,23.275831 C12.6075724,23.2657013 12.6010112,23.2592993 12.5934901,23.257841 L12.5934901,23.257841 Z M12.8583906,23.1452862 L12.8445485,23.1473072 L12.6598443,23.2396597 L12.6498822,23.2499052 L12.6498822,23.2499052 L12.6471943,23.2611114 L12.6650943,23.6906389 L12.6699349,23.7034178 L12.6699349,23.7034178 L12.678386,23.7104931 L12.8793402,23.8032389 C12.8914285,23.8068999 12.9022333,23.8029875 12.9078286,23.7952264 L12.9118235,23.7811639 L12.8776777,23.1665331 C12.8752882,23.1545897 12.8674102,23.1470016 12.8583906,23.1452862 L12.8583906,23.1452862 Z M12.1430473,23.1473072 C12.1332178,23.1423925 12.1221763,23.1452606 12.1156365,23.1525954 L12.1099173,23.1665331 L12.0757714,23.7811639 C12.0751323,23.7926639 12.0828099,23.8018602 12.0926481,23.8045676 L12.108256,23.8032389 L12.3092106,23.7104931 L12.3186497,23.7024347 L12.3186497,23.7024347 L12.3225043,23.6906389 L12.340401,23.2611114 L12.337245,23.2485176 L12.337245,23.2485176 L12.3277531,23.2396597 L12.1430473,23.1473072 Z" id="MingCute" fill-rule="nonzero"> </path> <path d="M15.3137,2 C15.8441,2 16.3529,2.21071 16.7279,2.58579 L21.4142,7.27208 C21.7893,7.64715 22,8.15586 22,8.68629 L22,15.3137 C22,15.8441 21.7893,16.3529 21.4142,16.7279 L16.7279,21.4142 C16.3528,21.7893 15.8441,22 15.3137,22 L8.68629,22 C8.15586,22 7.64715,21.7893 7.27208,21.4142 L2.58579,16.7279 C2.21071,16.3528 2,15.8441 2,15.3137 L2,8.68629 C2,8.15586 2.21071,7.64715 2.58579,7.27208 L7.27208,2.58579 C7.64715,2.21071 8.15586,2 8.68629,2 L15.3137,2 Z M12,15 C11.4477,15 11,15.4477 11,16 C11,16.5523 11.4477,17 12,17 C12.5523,17 13,16.5523 13,16 C13,15.4477 12.5523,15 12,15 Z M12,6 C11.48715,6 11.0644908,6.38604429 11.0067275,6.88337975 L11,7 L11,13 C11,13.5523 11.4477,14 12,14 C12.51285,14 12.9355092,13.613973 12.9932725,13.1166239 L13,13 L13,7 C13,6.44772 12.5523,6 12,6 Z" id="形状" fill="#e81127"> </path> </g> </g> </g> </g></svg>
          No data is available for the selected feedlot. Please choose a different feedlot or contact our office for assistance.
        </div>
        )
      )}

      {/* For Graco */ }
      {selectedFeedlot && selectedFeedlot.SarBatchID === "2" && (

        <div className="col-span-full flex justify-center ">
          <div className="flex justify-center">
            <div className="max-w-xl w-full sm:w-[500px] bg-gray-800 text-white rounded-2xl shadow-lg p-8 border border-blue-500">
              <div className="flex items-center justify-between mb-4">
                <h2 className="text-3xl font-semibold text-blue-400">Tank Level</h2>
                <p className="text-5xl font-bold text-blue-300">
                  {selectedFeedlot.TankLevel} <span className="text-3xl">Gallons</span>
                </p>
              </div>
              <div className="text-right text-base text-gray-400">
               
                Last updated: {selectedFeedlot.Time.toDate().toUTCString()}
              </div>
            </div>
          </div>    
        </div>  
      )}

    </div>
    );
}

export { ProtectedComponent };
